/* global swal, axios, ClipboardJS, LazyLoad, bulmaCollapsible */

const lsKeys = {
  token: 'token',
  userCode: 'user_code',
  viewType: {
    uploads: 'viewTypeUploads',
    uploadsAll: 'viewTypeUploadsAll'
  },
  selected: {
    uploads: 'selectedUploads',
    uploadsAll: 'selectedUploadsAll',
    albums: 'selectedAlbums',
    albumsAll: 'selectedAlbumsAll',
    users: 'selectedUsers'
  },
  originalNames: {
    uploads: 'originalNames',
    uploadsAll: 'originalNamesAll'
  }
}

const page = {
  // #dashboard
  section: null,
  // #page
  dom: null,

  // user token
  token: localStorage[lsKeys.token],
  userCode: localStorage[lsKeys.userCode],

  // from api/tokens/verify
  username: null,
  permissions: null,

  // sidebar menus
  menusContainer: null,
  menus: [],

  currentView: null,
  views: {
    // params of uploads view
    uploads: {
      type: localStorage[lsKeys.viewType.uploads],
      originalNames: localStorage[lsKeys.originalNames.uploads] === '1',
      album: null, // album's id
      pageNum: null
    },
    // params of uploads view (all)
    uploadsAll: {
      type: localStorage[lsKeys.viewType.uploadsAll],
      originalNames: localStorage[lsKeys.originalNames.uploadsAll] === '1',
      filters: null,
      pageNum: null,
      all: true
    },
    // params of albums view
    albums: {
      filters: null,
      pageNum: null
    },
    // params of albums view (all)
    albumsAll: {
      filters: null,
      pageNum: null,
      all: true
    },
    // params of users view
    users: {
      filters: null,
      pageNum: null
    },
    // params of reports view
    reports: {
      filters: null,
      pageNum: null
    }
  },
  prevPageNums: {
    uploads: null,
    uploadsAll: null,
    albums: null,
    albumsAll: null,
    users: null
  },

  // ids of selected items (shared across pages and will be synced with localStorage)
  selected: {
    uploads: [],
    uploadsAll: [],
    albums: [],
    albumsAll: [],
    users: [],
    reports: []
  },
  checkboxes: [],
  lastSelected: [],

  // select album dom for dialogs/modals
  selectAlbumContainer: null,

  // cache for dialogs/modals
  cache: {},

  clipboardJS: null,
  lazyLoad: null,
  albumsSidebarCollapse: null,
  albumsSidebarCollapsible: null,

  imageExts: ['.gif', '.jpeg', '.jpg', '.png', '.svg', '.tif', '.tiff', '.webp'],
  videoExts: ['.3g2', '.3gp', '.asf', '.avchd', '.avi', '.divx', '.evo', '.flv', '.h264', '.h265', '.hevc', '.m2p', '.m2ts', '.m4v', '.mk3d', '.mkv', '.mov', '.mp4', '.mpeg', '.mpg', '.mxf', '.ogg', '.ogv', '.ps', '.qt', '.rmvb', '.ts', '.vob', '.webm', '.wmv'],
  audioExts: ['.flac', '.mp3', '.wav', '.wma'],

  isSomethingLoading: false,
  fadingIn: null,

  albumTitleMaxLength: 70,
  albumDescMaxLength: 4000
}

page.unhide = () => {
  document.querySelector('#loader').classList.add('is-hidden')
  page.section.classList.remove('is-hidden')
}

// Dashboard design utils
page.dashboard = {
  openMain: `<main class="py-4 grid auto-rows-max gap-4 2xl:py-8 2xl:gap-8">`,
  closeMain: '</main>',
  openTable: `<div class="overflow-x-auto border border-line -mx-6 lg:rounded-lg lg:mx-0 max-[375px]:-mx-4 [&.grid-view]:border-0 [&.grid-view]:overflow-visible [&.grid-view]:m-0">
                <div class="inline-block min-w-full align-top">
              `,
  closeTable: `</div></div>`,
},

  page.dashboard.setTitle = (value) => {
    return `
  <div class="flex items-center gap-3 flex-wrap">
    <h1 class="font-cabinet text-2xl text-lead py-0.5">${value}</h1>
  </div>`
  }

// Handler for regular JS errors
page.onError = error => {
  console.error(error)

  const content = document.createElement('div')
  content.innerHTML = `
    <p><code>${error.toString()}</code></p>
    <p>Please check your console for more information.</p>
  `
  return swal({
    title: 'An error occurred!',
    icon: 'error',
    content
  })
}

// Handler for Axios errors
page.onAxiosError = error => {
  console.error(error)

  // Better Cloudflare errors
  const cloudflareErrors = {
    520: 'Unknown Error',
    521: 'Web Server Is Down',
    522: 'Connection Timed Out',
    523: 'Origin Is Unreachable',
    524: 'A Timeout Occurred',
    525: 'SSL Handshake Failed',
    526: 'Invalid SSL Certificate',
    527: 'Railgun Error',
    530: 'Origin DNS Error'
  }

  const statusText = cloudflareErrors[error.response.status] || error.response.statusText
  const description = error.response.data && error.response.data.description
    ? error.response.data.description
    : 'There was an error with the request.\nPlease check the console for more information.'

  return swal(`${error.response.status} ${statusText}`, description, 'error')
}

page.preparePage = () => {
  if (page.token) page.verifyToken(page.token)
  else window.location = 'auth'
}

page.checkClientVersion = apiVersion => {
  const self = document.querySelector('#mainScript')
  const match = self.src.match(/\?_=(\d+)$/)
  if (match && match[1] && match[1] !== apiVersion) {
    return swal({
      title: 'Update detected!',
      text: 'Client assets have been updated. Reload to display the latest version?',
      icon: 'info',
      buttons: {
        confirm: {
          text: 'Reload',
          closeModal: false
        }
      }
    }).then(() => {
      window.location.reload()
    })
  }
}

page.verifyToken = token => {
  axios.post('api/tokens/verify', { token }).then(response => {
    axios.defaults.headers.common.token = token
    localStorage[lsKeys.token] = token

    if (response.data.version) {
      page.checkClientVersion(response.data.version)
    }

    page.token = token
    page.username = response.data.username
    page.permissions = response.data.permissions
    page.prepareDashboard()
  }).catch(error => {
    return swal({
      title: 'An error occurred!',
      // text: error.response.data ? error.response.data.description : error.toString(),
      text: error.toString(),
      icon: 'error'
    }).then(() => {
      if (error.response.data && error.response.data.code === 10001) {
        localStorage.removeItem(lsKeys.token)
        window.location = 'auth'
      }
    })
  })
}

page.prepareDashboard = () => {
  page.section = document.querySelector('#dashboard')
  page.dom = page.section.querySelector('#page')

  // Capture all click events
  page.dom.addEventListener('click', page.domClick, true)

  // Selected: this.value
  // if (document.getElementById('my-select')){
  //   document.getElementById('my-select').addEventListener('change', function() {
  //     console.log('You selected: ', this.value);
  //     alert(this.value)
  //   });
  // }

  // Capture all submit events
  page.dom.addEventListener('submit', event => {
    // Prevent default if necessary
    if (event.target && event.target.classList.contains('prevent-default')) {
      return event.preventDefault()
    }
  }, true)

  page.menusContainer = document.querySelector('#menu')

  // All item menus in the sidebar
  const itemMenus = [
    { selector: '#itemUploads', onclick: page.getUploads },
    { selector: '#trashBin', onclick: page.trashBin },
    { selector: '#itemManageYourAlbums', onclick: page.getAlbums },
    { selector: '#itemManageToken', onclick: page.changeToken },
    { selector: '#itemChangePassword', onclick: page.changePassword },
    { selector: '#itemLogout', onclick: page.logout },
    { selector: '#itemManageUploads', onclick: page.getUploads, params: { all: true }, group: 'moderator' },
    { selector: '#itemManageAlbums', onclick: page.getAlbums, params: { all: true }, group: 'moderator' },
    { selector: '#itemStatistics', onclick: page.getStatistics, group: 'admin' },
    { selector: '#serverStats', onclick: page.serverStats, group: 'admin' },
    { selector: '#itemManageUsers', onclick: page.getUsers, group: 'admin' }
    // { selector: '#itemManageReports', onclick: page.getReports, group: 'admin' }
  ]

  for (let i = 0; i < itemMenus.length; i++) {
    // Skip item menu if not enough permission
    if (itemMenus[i].group && !page.permissions[itemMenus[i].group]) continue

    // Add onclick event listener
    const item = document.querySelector(itemMenus[i].selector)
    item.addEventListener('click', event => {
      if (page.isSomethingLoading) return page.warnSomethingLoading()

      // eslint-disable-next-line compat/compat
      itemMenus[i].onclick.call(null, Object.assign(itemMenus[i].params || {}, {
        trigger: event.currentTarget,
        forceScroll: true
      }))
    })

    item.classList.remove('is-hidden')
    page.menus.push(item)
  }

  // If at least a moderator, show administration section
  if (page.permissions.moderator) {
    document.querySelector('#itemLabelAdmin').classList.remove('is-hidden')
    document.querySelector('#itemListAdmin').classList.remove('is-hidden')
  }

  // Update text of logout button
  // document.querySelector('#itemLogout').innerHTML = `Logout ( ${page.username} )`

  // Update login name
  document.querySelector('#username').innerHTML = `${page.username}`

  // Finally display dashboard
  page.unhide()

  // Load albums sidebar
  page.getAlbumsSidebar()

  // if (typeof page.prepareShareX === 'function') page.prepareShareX()
}

page.logout = params => {
  page.updateTrigger(params.trigger, 'active')
  localStorage.removeItem(lsKeys.token)
  window.location = 'auth'
}

page.warnSomethingLoading = () => {
  swal('Please wait!', 'Something else is still loading\u2026', 'warning', {
    buttons: false,
    timer: 3000
  })
}

page.updateTrigger = (trigger, newState) => {
  if (!trigger) return

  // Disable menus container and pagination when loading
  if (newState === 'loading') {
    page.isSomethingLoading = true
    page.section.classList.add('is-loading')
  } else {
    page.section.classList.remove('is-loading')
    page.isSomethingLoading = false
  }

  if (newState === 'loading') {
    trigger.classList.add('is-loading')
  } else if (newState === 'active') {
    if (trigger.parentNode.tagName === 'LI' && !trigger.className.includes('pagination-link')) {
      for (let i = 0; i < page.menus.length; i++) {
        page.menus[i].classList.remove('is-active')
        page.menus[i].classList.remove('on')
      }
      trigger.classList.add('is-active')
      trigger.classList.add('on')
    }
    trigger.classList.remove('is-loading')
  } else {
    trigger.classList.remove('is-loading')
    trigger.classList.remove('is-active')
    trigger.classList.remove('on')
  }
}

page.getItemID = element => {
  // This expects the item's parent to have the item's ID
  let parent = element.parentNode
  // If the element is part of a set of controls, use the container's parent instead
  if (element.parentNode.classList.contains('controls')) parent = parent.parentNode
  return parseInt(parent.dataset.id)
}

page.domClick = event => {
  // We are processing clicks this way to avoid using "onclick" attribute
  // Apparently we will need to use "unsafe-inline" for "script-src" directive
  // of Content Security Policy (CSP), if we want to use "onclick" attribute
  // Though I think that only applies to some browsers (?)
  // Of course it wouldn't have mattered if we didn't use CSP to begin with
  // Anyway, I personally would rather not use "onclick" attribute
  let element = event.target
  if (!element) return

  // Delegate click events to their A or BUTTON parents
  if (['I'].includes(element.tagName) && ['SPAN'].includes(element.parentNode.tagName)) {
    element = element.parentNode
  }
  if (['SPAN'].includes(element.tagName) && ['A', 'BUTTON'].includes(element.parentNode.tagName)) {
    element = element.parentNode
  }

  // Skip elements that have no action data
  if (!element.dataset || !element.dataset.action) return

  // Skip disabled elements
  if (element.hasAttribute('disabled')) return

  event.stopPropagation() // maybe necessary
  const id = page.getItemID(element)
  const action = element.dataset.action

  switch (action) {
    // Uploads
    case 'view-list':
      return page.setUploadsView('list', element)
    case 'view-thumbs':
      return page.setUploadsView('thumbs', element)
    case 'toggle-original-names':
      return page.toggleOriginalNames(element)
    case 'add-to-album':
      return page.addToAlbum(id)
    case 'delete-upload':
      return page.deleteUpload(id)
    case 'add-selected-uploads-to-album':
      return page.addSelectedUploadsToAlbum()
    case 'bulk-delete-uploads':
      return page.bulkDeleteUploads()
    case 'display-preview':
      return page.displayPreview(id)
    // Manage uploads
    case 'upload-filters-help':
      return page.uploadFiltersHelp(element)
    case 'filter-uploads':
      return page.filterUploads(element)
    case 'manage-uploads-filter':
      return page.showModal('createUploadsFilter')
    // Manage your albums
    case 'submit-album':
      return page.submitAlbum(element)
    case 'edit-album':
      return page.editAlbum(id)
    case 'edit-file':
        return page.editFile(id)
    case 'disable-album':
      return page.disableAlbum(id)
    case 'delete-album':
      return page.deleteAlbum(id)
    case 'view-album-uploads':
      return page.viewAlbumUploads(id, element)
    case 'filter-albums':
      return page.filterAlbums(element)
    case 'new-album':
      return page.showModal('createNewAlbum')
    case 'manage-album-filter':
      return page.showModal('createAlbumsFilter')
    // Manage users
    case 'create-user':
      return page.createUser()
    case 'edit-user':
      return page.editUser(id)
    case 'disable-user':
      return page.disableUser(id)
    case 'delete-user':
      return page.deleteUser(id)
    case 'view-user-uploads':
      return page.viewUserUploads(id, element)
    // Others
    case 'get-new-token':
      return page.getNewToken(element)
    // Uploads & Users
    case 'clear-selection':
      return page.clearSelection()
    case 'select':
      return page.select(element, event)
    case 'select-all':
      return page.selectAll(element)
    case 'page-ellipsis':
      return page.focusJumpToPage(element)
    case 'page-prev':
    case 'page-next':
    case 'page-goto':
    case 'jump-to-page':
      return page.switchPage(action, element)
    // Manage Reports
    case 'delete-report':
      return page.deleteReport(id, element)
    case 'filter-reports':
      return page.filterReports(element)
    case 'generate-slug':
      return page.generateSlug(id)
    case 'album-purge-cache':
      return page.purgeCache(id)
    // UI common actions
    case 'close-modal':
      page.closeModal(element)
  }
}

page.fadeInDom = disableFading => {
  if (page.fadingIn) {
    clearTimeout(page.fadingIn)
    page.dom.classList.remove('fade-in')
  }

  if (!disableFading) {
    page.dom.classList.add('fade-in')
    page.fadingIn = setTimeout(() => {
      page.dom.classList.remove('fade-in')
    }, 500)
  }
}

page.scrollToDom = disableSmooth => {
  page.dom.scrollIntoView({
    behavior: disableSmooth ? 'auto' : 'smooth',
    block: 'start',
    inline: 'nearest'
  })
}

page.getByView = (view, get) => {
  switch (view) {
    case 'uploads':
    case 'uploadsAll':
      return {
        type: 'uploads',
        func: page.getUploads
      }[get]
    case 'albums':
    case 'albumsAll':
      return {
        type: 'albums',
        func: page.getAlbums
      }[get]
    case 'users':
      return {
        type: 'users',
        func: page.getUsers
      }[get]
    default:
      return null
  }
}

page.switchPage = (action, element) => {
  if (page.isSomethingLoading) return page.warnSomethingLoading()

  // eslint-disable-next-line compat/compat
  const params = Object.assign(page.views[page.currentView], {
    trigger: element
  })

  const func = page.getByView(page.currentView, 'func')

  switch (action) {
    case 'page-prev':
      params.pageNum = page.views[page.currentView].pageNum - 1
      if (params.pageNum < 0) {
        return swal('An error occurred!', 'This is already the first page.', 'error')
      }
      return func(params)
    case 'page-next':
      params.pageNum = page.views[page.currentView].pageNum + 1
      return func(params)
    case 'page-goto':
      params.pageNum = parseInt(element.dataset.goto)
      return func(params)
    case 'jump-to-page': {
        const jumpToPage = document.getElementById('pageInput');
        if (!jumpToPage.checkValidity()) return;
        const parsed = parseInt(jumpToPage.value);
        params.pageNum = isNaN(parsed) ? 0 : (parsed - 1);
        if (params.pageNum < 0) params.pageNum = 0;
        return func(params);
      }
  }
}

page.focusJumpToPage = element => {
  const jumpToPage = document.querySelector(`#${element.dataset.jumpid || 'jumpToPage'}`)
  if (!jumpToPage) return
  jumpToPage.focus()
  jumpToPage.select()
}

page.getUploads = (params = {}) => {
  if (params && params.all && !page.permissions.moderator) {
    return swal('An error occurred!', 'You cannot do this!', 'error')
  }

  if (page.isSomethingLoading) return page.warnSomethingLoading()

  page.updateTrigger(params.trigger, 'loading')

  if (typeof params.pageNum !== 'number' || params.pageNum < 0) {
    params.pageNum = 0
  }

  const url = typeof params.album !== 'undefined'
    ? `api/album/${params.album}/${params.pageNum}`
    : `api/uploads/${params.pageNum}`

  const headers = {}
  if (params.all) headers.all = '1'
  if (params.filters) {
    headers.filters = params.filters
    // Send client timezone offset if properly using date: and/or :expiry filters
    // Server will pretend client is on UTC if unset
    if (/(^|\s)(date|expiry):[\d"]/.test(params.filters)) {
      headers.minoffset = new Date().getTimezoneOffset()
    }
  }

  axios.get(url, { headers }).then(response => {
    if (response.data.success === false) {
      if (response.data.description === 'No token provided') {
        return page.verifyToken(page.token)
      } else {
        page.updateTrigger(params.trigger)
        return swal('An error occurred!', response.data.description, 'error')
      }
    }

    const pages = Math.ceil(response.data.count / 25)
    const files = response.data.files
    if (params.pageNum && (files.length === 0)) {
      page.updateTrigger(params.trigger)
      if (params.autoPage) {
        params.pageNum = pages - 1
        return page.getUploads(params)
      } else {
        return swal('An error occurred!', `There are no more uploads to populate page ${params.pageNum + 1}.`, 'error')
      }
    }

    page.currentView = params.all ? 'uploadsAll' : 'uploads'
    page.cache = {}

    const albums = response.data.albums
    const users = response.data.users
    // eslint-disable-next-line no-unused-vars
    const basedomain = response.data.basedomain

    if (params.pageNum < 0) params.pageNum = Math.max(0, pages + params.pageNum)
    const pagination = page.paginate(response.data.count, 50, params.pageNum)

    const filter = `
    <div class="column">
      <form class="prevent-default">
        <div class="field has-addons">
          <div class="control is-expanded">
            <input id="filters" class="input is-small" type="text" placeholder="Filter uploads" value="${page.escape(params.filters || '')}">
          </div>
          <div class="control">
            <button type="button" class="button is-small is-primary is-outlined" title="Help?" data-action="upload-filters-help"${params.all ? ' data-all="true"' : ''}>
              <span class="icon">
                <i class="icon-help-circled"></i>
              </span>
            </button>
          </div>
          <div class="control">
            <button type="submit" class="button is-small is-info is-outlined" title="Filter uploads" data-action="filter-uploads">
              <span class="icon">
                <i class="icon-filter"></i>
              </span>
            </button>
          </div>
        </div>
      </form>
    </div>
  `

    // Whether there are any unselected items
    let unselected = false

    const showOriginalNames = page.views[page.currentView].originalNames
    const hasExpiryDateColumn = files.some(file => typeof file.expirydate !== 'undefined')
    const showThumbs = (page.views[page.currentView].type === 'thumbs')
    const hasFilter = page.escape(params.filters || '') ? true : false

    for (let i = 0; i < files.length; i++) {
      // Build full URLs
      files[i].file = `${files[i].basedomain}/${files[i].name}`
      if (files[i].thumb) {
        files[i].thumb = `${files[i].thumb}`
      }

      // Determine types
      const extname = files[i].extname.toLowerCase()
      if (page.imageExts.includes(extname)) {
        files[i].type = 'picture'
      } else if (page.videoExts.includes(extname)) {
        files[i].type = 'video'
      } else if (page.audioExts.includes(extname)) {
        files[i].type = 'audio'
      } else {
        files[i].type = 'other'
      }

      files[i].previewable = files[i].thumb || files[i].type === 'audio'

      // Cache bare minimum data for thumbnails viewer
      page.cache[files[i].id] = {
        name: files[i].name,
        original: files[i].original,
        extname: files[i].extname,
        thumb: files[i].thumb,
        file: files[i].file,
        type: files[i].type,
        previewable: files[i].previewable
      }

      // Prettify
      files[i].prettyBytes = page.getPrettyBytes(parseInt(files[i].size))
      files[i].prettyDate = page.getPrettyDate(new Date(files[i].timestamp * 1000))

      if (hasExpiryDateColumn) {
        files[i].prettyExpiryDate = files[i].expirydate
          ? page.getPrettyDate(new Date(files[i].expirydate * 1000))
          : null
      }

      // Update selected status
      files[i].selected = page.selected[page.currentView].includes(files[i].id)
      if (!files[i].selected) unselected = true

      // Appendix (display album or user)
      if (params.all) {
        files[i].appendix = files[i].userid
          ? users[files[i].userid] || ''
          : ''
      } else if (typeof params.album === 'undefined') {
        files[i].appendix = files[i].albumid
          ? albums[files[i].albumid] || ''
          : ''
      }
    }

    const createUploadsFilter = `
      <!-- modal -->
        <!-- add class "show" to see -->
        <div id="createUploadsFilter" class="bg-back/80 fixed inset-0 w-full h-full z-50 place-items-end sm:place-items-center hidden [&.show]:grid hidden">
          <div class="bg-mute p-4 w-full rounded-t-xl max-h-full grid auto-rows-max gap-6 overflow-auto sm:rounded-lg sm:max-w-3xl sm:p-8">
            <div class="grid auto-rows-max gap-4 relative">
              <button class="btn btn-seco-ghost text-xl absolute end-0 top-0 p-0 -m-2 sm:-m-4" type="button" aria-label="Close" data-action="close-modal">
                <span class="ic-x-close"></span>
              </button>
              <!-- <span class="ic-folder w-12 h-12 ic-before before:text-2xl text-main bg-main/10 rounded-full grid place-content-center"></span> -->
              <div class="text-2xl font-bold text-subs font-cabinet">Filter Albums</div>
            </div>
            <div class="grid auto-rows-max gap-4">
              <form class="prevent-default">
              <div class="grid auto-rows-max gap-1">
                <label class="font-semibold text-subs sr-only" for="filters">Name</label>
                <input class="bg-body sm:text-sm" type="text" id="filters" placeholder="Filter Uploads" value="${page.escape(params.filters || '')}">
                <button type="submit" class="button is-small is-info is-outlined hidden" title="Filter albums" data-action="filter-uploads">
                  <span class="icon">
                    <i class="icon-filter"></i>
                  </span>
                </button>
                <p class="text-xs mt-1">Press <span class="font-semibold">ENTER</span> to filter</p>
              </div>
              </form>
            </div>
            <div class="bg-body border-t border-line p-4 sm:rounded-b-xl -m-4 mt-0 sm:-m-8 sm:mt-0 sm:p-8">
              <details class="group/item">
                <summary class="flex gap-3 cursor-pointer group-open/item:mb-4 sm:group-open/item:mb-8 sticky top-0 bg-body before:bg-body before:absolute before:-inset-4 sm:before:-inset-8 before:-z-10 select-none">
                  <span class="ic-help-circle text-xl text-main" aria-hidden="true"></span>
                  <div class="flex-1 grid auto-rows-max gap-1">
                    <span class="text-main">Sort list</span>
                    <span class="text-xs">Everything you need to know about filters.</span>
                  </div>
                  <span class="btn btn-main-light rounded-full p-0 ic-chevron-right ic-before text-lg rotate-90 group-open/item:-rotate-90" aria-hidden="true"></span>
                </summary>
                <div class="entry bg-mute border border-soft p-4 rounded-lg">
                  <p>There is only 1 filter key, namely <strong>albumid</strong>.<br> This key can be specified more than once.<br> Special case such as uploads with no albums, use <code class="inline-block">albumid:-</code>.
                  </p>
        
                  <p>To exclude certain albums while still listing every other uploads, add negation sign <code class="inline-block">(-)</code> before the keys.<br> Negation sign can also be used to exclude the special case mentioned above <code class="inline-block">(i.e. -albumid:-)</code>.</p>
        
                  <p>There are 2 range keys: <strong>date</strong> (upload date) and <strong>expiry</strong> (expiry date).<br> Their format is: <code class="inline-block">"YYYY/MM/DD HH:MM:SS-YYYY/MM/DD HH:MM:SS"</code> ("from" date and "to" date respectively).<br> You may specify only one of the dates.<br> If "to" date is missing, 'now' will be used. If "from" date is missing, 'beginning of time' will be used.<br> If any of the subsequent date or time units are not specified, their first value will be used (e.g. January for month, 1 for day, and so on).<br> If only time is specified, today's date will be used.<br> If you do not need to specify both date and time, you may omit the double quotes.<br> In conclusion, the following examples are all valid: <code class="inline-block">date:"2020/01/01 01:23-2018/01/01 06"</code>, <code class="inline-block">expiry:-2020/05</code>, <code class="inline-block">date:12:34:56</code>.<br> These keys can only be specified once each.</p>
        
                  <p><strong>Timezone?</strong> Feel free to query the dates with your own timezone.<br> API requests to the filter endpoint will attach your browser's timezone offset, so the server will automatically calculate timezone differences.</p>
        
                  <p>Matches can also be sorted with <strong>sort</strong> keys.<br> Their formats are: <code class="inline-block">sort:columnName[:d[escending]]</code>, where <code class="inline-block">:d[escending]</code> is an optional tag to set the direction to descending.<br> This key must be used with internal column names used in the database (<code class="inline-block">id</code>, <code class="inline-block">albumid</code>, and so on), but there are 2 shortcuts available: date for <code class="inline-block">timestamp</code> column and expiry for <code class="inline-block">expirydate</code> column.<br> This key can also be specified more than once, where their order will decide the sorting steps.</p>
        
                  <p>Finally, there are type-<strong>is</strong> keys to refine by types.<br> You can use <code class="inline-block">is:image</code>, <code class="inline-block">is:video</code>, and <code class="inline-block">is:audio</code> to list images, videos, audios respectively.<br> This will only use image, video and audio extensions that are whitelisted internally in the safe.<br> For images and videos specifically, they will be the ones whose thumbnails can be generated by the safe.<br> Negation sign works for this key as well.<br> Mixing inclusion and exclusion is not allowed (i.e. <code class="inline-block">is:image -is:video</code>, since the second key is redundant).</p>
        
                  <p>Any leftover keywords which do not use keys (non-keyed keywords) will be matched against the matches' file names.<br> Excluding certain keywords is also supported by adding negation sign before the keywords.</p>
        
                  <h4>Internal steps:</h4>
                  <ul>
                    <li>Filter uploads using date key, if any.</li>
                    <li>Refine matches using expiry key, if any.</li>
                    <li>Refine matches using type-is keys, if any.</li>
                    <li>Refine matches using ANY non-keyed keywords, if any.</li>
                    <li>Filter matches using ALL exclusion non-keyed keywords, if any.</li>
                    <li>Sort matches using sorting keys, if any.</li>
                  </ul>
        
                  <h4>Examples:</h4>
                  <ul>
                    <li>
                      Uploads without albums:<br>
                      <code class="inline-block">albumid:-</code>
                    </li>
                    <li>
                      ALL uploads, but NOT the ones from album with ID 69:<br>
                      <code class="inline-block">-albumid:69</code>
                    </li>
                    <li>
                      Uploads uploaded since "1 June 2019 00:00:00":<br>
                      <code class="inline-block">date:2019/06</code>
                    </li>
                    <li>
                      Uploads uploaded between "7 April 2020 12:00:00" and "7 April 2020 23:59:59":<br>
                      <code class="inline-block">date:"2020/04/07 12-2020/04/07 23:59:59"</code>
                    </li>
                    <li>
                      Uploads uploaded before "5 February 2020 00:00:00":<br>
                      <code class="inline-block">date:-2020/02/05</code>
                    </li>
                    <li>
                      Uploads which file names match "*.gz" but NOT "*.tar.gz":<br>
                      <code class="inline-block">*.gz -*.tar.gz</code>
                    </li>
                    <li>
                      Sort matches by "size" column in ascending and descending order respectively:<br>
                      <code class="inline-block">*.txt sort:size</code><br>
                      <code class="inline-block">*.mp4 sort:size:d</code>
                    </li>
                  </ul>
        
                  <p><strong>Friendly reminder:</strong> This window can be scrolled up!</p>
                </div>
              </details>
            </div>
          </div>
        </div>
    `

    const title = page.dashboard.setTitle('Uploads')

    const options = `
      <!-- options -->
      <div class="flex gap-2 items-center flex-wrap">
        <div class="bg-soft p-1 rounded-lg flex gap-1">
          <button class="btn btn-sm p-0 tooltip-top [&.on]:bg-body [&.on]:text-subs ${!showThumbs ? 'on' : ''}" aria-label="List view" type="button" data-action="view-list">
            <span class="ic-layout-alt-03 text-lg" aria-hidden="true"></span>
          </button>
          <button class="btn btn-sm p-0 tooltip-top [&.on]:bg-body [&.on]:text-subs ${showThumbs ? 'on' : ''}" aria-label="Grid view" type="button" data-action="view-thumbs">
            <span class="ic-layout-grid-01 text-lg" aria-hidden="true"></span>
          </button>
        </div>
        <button class="btn btn-seco-ghost text-text rounded-lg [&.on]:bg-body [&.on]:text-subs ${hasFilter ? 'on' : ''}" type="button" data-action="manage-uploads-filter">
          <span class="ic-filter-lines text-lg" aria-hidden="true"></span> Filter
        </button>
        <!-- add class "on" -->
      </div>      
    `

    const navBar = `
      <div class="grid auto-rows-max gap-4">
        <!-- top -->
        <div class="flex items-center justify-between flex-wrap gap-4">
        ${options}
        ${pagination}
      </div>
    `

    const selected = `
    <div id="albumContainer"></div>
    <div class="selected bg-mute border border-line p-4 rounded-lg flex flex-wrap justify-between gap-4">
      <div class="flex gap-3 items-center">
        <span id="selectedItems" class="hidden"><span class="font-bold">2</span> selected</span>
        <button class="btn btn-main-light btn-sm text-xs font-semibold" type="button" data-action="clear-selection">Clear selection</button>
      </div>
      <div class="flex gap-2 w-full flex-wrap sm:w-auto">
        <button class="btn btn-seco-outline btn-sm text-xs gap-1 font-semibold ic-plus ic-before before:text-base flex-1 max-[374px]:flex-none max-[374px]:w-full sm:flex-none" type="button" data-action="add-selected-uploads-to-album">Bulk add to album</button>
        <button class="btn btn-seco-outline btn-sm text-xs gap-1 font-semibold ic-trash-01 ic-before before:text-base flex-1 max-[374px]:flex-none max-[374px]:w-full sm:flex-none" type="button" data-action="bulk-delete-uploads">Bulk delete</button>
      </div>
    </div>    
    `

    // Do some string replacements for bottom controls
    const bottomNavBar = navBar
      .replace(/for="navMySelect"/, `for="bottomNavMySelect"`)
      .replace(/id="navMySelect"/, `id="bottomNavMySelect"`)

    if (page.views[page.currentView].type === 'thumbs') {
      page.dom.innerHTML = `
        ${page.dashboard.openMain}
        ${title}
        ${navBar}
        ${selected}
        <h2> thumb view </h2>
        <!-- table -->
				<!-- add class "grid-view" to show the grid view and "original-name" to show/hidde that column -->
        <div class="overflow-x-auto border border-line -mx-6 lg:rounded-lg lg:mx-0 max-[375px]:-mx-4 [&.grid-view]:border-0 [&.grid-view]:overflow-visible [&.grid-view]:m-0 grid-view original-name">
          <div class="inline-block min-w-full align-top">
            <table class="min-w-full divide-y divide-line [.grid-view_&]:grid [.grid-view_&]:divide-y-0">
              <thead class="[.grid-view_&]:hidden">
                <tr>
									<th scope="col" class="px-4 py-3.5 pe-0 w-9 whitespace-nowrap text-start font-semibold relative">
                    <input id="selectAll" class="checkbox bg-body" type="checkbox" title="Unselect all" data-action="select-all">
                  </th>
									<th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">File name</th>
									${showOriginalNames ? `<th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold [.original-name_&]:table-cell">Original name</th>` : ''}
                  <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Views</th>
									<th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Album</th>
									<th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Size</th>
									<th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Upload date</th>
									<th scope="col" class="px-4 py-3.5 whitespace-nowrap text-end font-semibold">${response.data.count} total</th>
								</tr>
							</thead>
              <tbody id="table" class="divide-y divide-line [.grid-view_&]:grid [.grid-view_&]:gap-4 [.grid-view_&]:divide-y-0 [.grid-view_&]:grid-cols-repeat [.grid-view_&]:[--size:14rem]">
              </tbody>
            </table>
          </div>
        </div>
        ${bottomNavBar}
        </div>
        ${page.dashboard.closeMain}
        ${createUploadsFilter}
      `

      const table = document.querySelector('#table')

      for (let i = 0; i < files.length; i++) {
        const upload = files[i]

        upload.last_visited_at = page.getPrettyDate(new Date(upload.last_visited_at))

        let showThumbnail = ''
        if (typeof upload.thumb !== 'undefined') {
          showThumbnail = `
            <div class="text-fire aspect-video hidden place-content-center relative z-10 [.grid-view_&]:grid">
              <img class="aspect-video object-cover rounded-lg"   src="${upload.thumb}" alt="${upload.original}" data-src="${upload.thumb}">
            </div>          
          `
        } else {
          let extension = upload.extname || 'N/A'
          extension = extension.replace('.', '')
          showThumbnail = `
            <div class="text-fire aspect-video hidden place-content-center relative z-10 [.grid-view_&]:grid">
              <span class="inset-0 m-auto h-12 w-12 pt-[22px] text-center text-xs text-fore font-semibold leading-5 absolute z-20 uppercase">${extension}</span>
              <svg class="relative z-10" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M44 27H4L1 23L5 19H43L47 23L44 27Z" fill="currentColor"/>
                <path opacity="0.3" d="M44 27H4L1 23L5 19H43L47 23L44 27Z" fill="black"/>
                <path d="M41 47H7C5.895 47 5 46.105 5 45V3C5 1.895 5.895 1 7 1H31L43 13V45C43 46.105 42.105 47 41 47Z" fill="#E6E6E6"/>
                <path d="M31 1V11C31 12.105 31.895 13 33 13H43L31 1Z" fill="#B3B3B3"/>
                <path d="M45 41H3C1.895 41 1 40.105 1 39V23H47V39C47 40.105 46.105 41 45 41Z" fill="currentColor"/>
              </svg>
            </div>          
          `
        }

        const tr = document.createElement('tr');
        tr.classList.add("hover:bg-mute", "has-[:checked]:bg-mute", "[.grid-view_&]:grid", "[.grid-view_&]:ring-1", "[.grid-view_&]:ring-inset", "[.grid-view_&]:ring-line", "[.grid-view_&]:rounded-lg", "[.grid-view_&]:relative", "[.grid-view_&]:text-center", "[.grid-view_&]:has-[:checked]:ring-2", "[.grid-view_&]:has-[:checked]:ring-main");
        tr.dataset.repeat = '8';
        tr.dataset.id = upload.id;

        tr.innerHTML = `        
          <td class="controls px-4 py-3 pe-0 w-9 whitespace-nowrap relative [.grid-view_&]:static [.grid-view_&]:py-4">
            <input type="checkbox" class="checkbox" name="checkbox-${i}" title="Select" data-index="${i}" data-action="select"${upload.selected ? ' checked' : ''}>
          </td>
          <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:py-0">
            <a class="truncate-container [.grid-view_&]:grid [.grid-view_&]:gap-4 [.grid-view_&]:text-center truncate-text" href="${upload.finalurl}" target="_blank">
              ${showThumbnail}
              <span class="text-lead font-medium truncate-text">${upload.original}</span>
            </a>
          </td>
          ${showOriginalNames ? `<td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:truncate [.grid-view_&]:pt-1 [.grid-view_&]:py-0 [.grid-view_&]:text-xs [.original-name_&]:table-cell [.original-name.grid-view_&]:block">${upload.original}</td>` : ''}
          <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden">${typeof params.album === 'undefined' ? upload.appendix : ''}</td>
          <td class="file_views px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden" data-id="${upload.id}" style="text-align: center"></td>
          <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden" data-bytes="${upload.size}" style="text-align: center">${upload.prettyBytes}</td>
          <td class="px-4 py-3 hidden justify-center [.grid-view_&]:flex [.grid-view_&]:gap-1 [.grid-view_&]:text-xs [.grid-view_&]:pt-1 [.grid-view_&]:pb-4">
            <span class="truncate">${typeof params.album === 'undefined' ? upload.appendix : ''}</span>
            <span class="shrink-0 truncate">-</span>
            <span class="shrink-0 truncate" data-bytes="${upload.size}">${upload.prettyBytes}</span>
          </td>
          <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden"><span class="inline-block whitespace-normal max-w-[10ch]" data-timestamp="${upload.timestamp}" style="text-align: center">${upload.prettyDate}</span></td>
          <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:absolute [.grid-view_&]:end-2 [.grid-view_&]:top-2 [.grid-view_&]:p-0" style="text-align: center">
            <div class="flex gap-2 justify-end" data-id="${upload.id}">
              <button class="btn btn-seco-outline btn-sm p-0 tooltip-top" aria-label="Edit File" type="button" data-action="edit-file">
               <span class="ic-edit-02 text-base" aria-hidden="true"></span>
              </button>
              <button class="btn btn-seco-outline btn-sm p-0 tooltip-top clipboard-js" aria-label="Copy link" type="button" data-clipboard-text="${upload.finalurl}">
                <span class="ic-copy-02 text-base" aria-hidden="true"></span>
              </button>
              ${params.all ? '' : `
              <button class="btn btn-seco-outline btn-sm p-0 tooltip-top" aria-label="Add to album" type="button" data-action="add-to-album">
                <span class="ic-plus text-base" aria-hidden="true"></span>
              </button>
              `}
              <button class="btn btn-seco-outline btn-sm p-0 tooltip-top" aria-label="Delete" type="button" data-action="delete-upload">
                <span class="ic-trash-01 text-base" aria-hidden="true"></span>
              </button>
            </div>
          </td>
        `;

        table.appendChild(tr);

        // Fetch download count for the newly created row using the file ID
        const fileId = upload.id;
        const fileViewCell = tr.querySelector('.file_views');

        // Make API call to get download count
        axios.get(`https://stats.bunkr.ru/api/file/stats/${fileId}`)
          .then(response => {
            if (response.data && response.data.downloadCount !== undefined) {
              // Populate the file views column with download count
              fileViewCell.innerText = response.data.downloadCount;
            } else {
              // If no downloadCount, set to 0
              fileViewCell.innerText = 0;
            }
          })
          .catch(error => {
            console.error(`Error fetching stats for file ${fileId}:`, error);
            // On error, set download count to 0
            fileViewCell.innerText = 0;
          });

        page.checkboxes = table.querySelectorAll('.checkbox[data-action="select"]');

      }
    } else {
      const allAlbums = params.all && params.filters && params.filters.includes('albumid:')
      page.dom.innerHTML = `
        ${page.dashboard.openMain}
        ${title}
        ${navBar}
        ${selected}
        <!-- table -->
				<!-- add class "grid-view" to show the grid view and "original-name" to show/hidde that column -->
				<div class="overflow-x-auto border border-line -mx-6 lg:rounded-lg lg:mx-0 max-[375px]:-mx-4 [&.grid-view]:border-0 [&.grid-view]:overflow-visible [&.grid-view]:m-0">
					<div class="inline-block min-w-full align-top">
            <table class="min-w-full divide-y divide-line [.grid-view_&]:grid [.grid-view_&]:divide-y-0">
              <thead class="[.grid-view_&]:hidden">
                <tr>
                  <th scope="col" class="px-4 py-3.5 pe-0 w-9 whitespace-nowrap text-start font-semibold relative">
                    <input id="selectAll" class="checkbox bg-body" type="checkbox" title="Unselect all" data-action="select-all">
                  </th>
                  <th title="Key: name" scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">File name</th>
                  ${showOriginalNames ? `<th title="Key: original" scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold [.original-name_&]:table-cell">Original name</th>` : ''}
                  ${typeof params.album === 'undefined' ? `<th title="Key: ${params.all ? 'userid' : 'albumid'}" scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold" style="text-align: center">${params.all ? 'User' : 'Album'}</th>` : ''}
                  ${allAlbums ? '<th title="Key: albumid" scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Album</th>' : ''}
                  <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold" style="text-align: center">Views</th>
                  <th title="Key: size" scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Size</th>
                  ${params.all ? '<th title="Key: ip" scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">IP</th>' : ''}
                  <th title="Key: timestamp" scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Upload date</th>
                  <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-end font-semibold">${response.data.count} total</th>
                </tr>
              </thead>
              <tbody id="table" class="divide-y divide-line [.grid-view_&]:grid [.grid-view_&]:gap-4 [.grid-view_&]:divide-y-0 [.grid-view_&]:grid-cols-repeat [.grid-view_&]:[--size:14rem]">
              </tbody>
            </table>
          </div>
        </div>
        ${bottomNavBar}
        </div>
        ${page.dashboard.closeMain}
        ${createUploadsFilter}
      `

      const table = document.querySelector('#table')

      for (let i = 0; i < files.length; i++) {
        const upload = files[i];
        const tr = document.createElement('tr');
        tr.classList.add("hover:bg-mute", "has-[:checked]:bg-mute", "[.grid-view_&]:grid", "[.grid-view_&]:ring-1", "[.grid-view_&]:ring-inset", "[.grid-view_&]:ring-line", "[.grid-view_&]:rounded-lg", "[.grid-view_&]:relative", "[.grid-view_&]:text-center", "[.grid-view_&]:has-[:checked]:ring-2", "[.grid-view_&]:has-[:checked]:ring-main");
        tr.dataset.repeat = '9';

        // Formatting the last_visited_at field
        upload.last_visited_at = page.getPrettyDate(new Date(upload.last_visited_at));
        tr.dataset.id = upload.id;

        tr.innerHTML = `
          <td class="controls px-4 py-3 pe-0 w-9 whitespace-nowrap relative [.grid-view_&]:static [.grid-view_&]:py-4">
            <input type="checkbox" class="checkbox" name="checkbox-${i}" title="Select" data-index="${i}" data-action="select"${upload.selected ? ' checked' : ''}>
          </td>
          <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:py-0">
            <a class="truncate-container [.grid-view_&]:grid [.grid-view_&]:gap-4 [.grid-view_&]:text-center truncate-text" href="${upload.finalurl}" title="${upload.file}" target="_blank">
              <span class="text-lead font-medium [.grid-view_&]:truncate truncate-text" style="font-size: 11px !important;">${upload.original}</span>
            </a>                
          </td>
          ${showOriginalNames ? `<td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:truncate [.grid-view_&]:pt-1 [.grid-view_&]:py-0 [.grid-view_&]:text-xs [.original-name_&]:table-cell [.original-name.grid-view_&]:block">${upload.original}</td>` : ''}
          ${typeof params.album === 'undefined' ? `<td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden">${upload.appendix}</td>` : ''}
          ${allAlbums ? `<td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden">${upload.albumid ? (albums[upload.albumid] || '') : ''}</td>` : ''}
          <td class="file_views px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden" data-id="${upload.id}" style="text-align: center"></td>
          <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden" data-bytes="${upload.size}">${upload.prettyBytes}</td>
          ${params.all ? `<td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden"><span class="inline-block whitespace-normal max-w-[10ch]">${upload.ip || ''}</span></td>` : ''}
          <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden"><span class="inline-block whitespace-normal max-w-[10ch]" data-timestamp="${upload.timestamp}">${upload.prettyDate}</span></td>
          <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:absolute [.grid-view_&]:end-2 [.grid-view_&]:top-2 [.grid-view_&]:p-0">
            <div class="flex gap-2 justify-end" data-id="${upload.id}">
              <button class="btn btn-seco-outline btn-sm p-0 tooltip-top" aria-label="Edit File" type="button" data-action="edit-file">
               <span class="ic-edit-02 text-base" aria-hidden="true"></span>
              </button>
              <button class="btn btn-seco-outline btn-sm p-0 tooltip-top clipboard-js" aria-label="Copy link" type="button" data-clipboard-text="${upload.finalurl}">
                <span class="ic-copy-02 text-base" aria-hidden="true"></span>
              </button>
              ${params.all ? '' : `
              <button class="btn btn-seco-outline btn-sm p-0 tooltip-top" aria-label="Add to album" type="button" data-action="add-to-album">
                <span class="ic-plus text-base" aria-hidden="true"></span>
              </button>
              `}
              <button class="btn btn-seco-outline btn-sm p-0 tooltip-top" aria-label="Delete" type="button" data-action="delete-upload">
                <span class="ic-trash-01 text-base" aria-hidden="true"></span>
              </button>
            </div>
          </td>
        `;

        // Append the row to the table
        table.appendChild(tr);

        // Fetch download count for the newly created row using the file ID
        const fileId = upload.id;
        const fileViewCell = tr.querySelector('.file_views');

        // Make API call to get download count
        axios.get(`https://stats.bunkr.ru/api/file/stats/${fileId}`)
          .then(response => {
            if (response.data && response.data.downloadCount !== undefined) {
              // Populate the file views column with download count
              fileViewCell.innerText = response.data.downloadCount;
            } else {
              // If no downloadCount, set to 0
              fileViewCell.innerText = 0;
            }
          })
          .catch(error => {
            console.error(`Error fetching stats for file ${fileId}:`, error);
            // On error, set download count to 0
            fileViewCell.innerText = 0;
          });

        // Update checkboxes
        page.checkboxes = table.querySelectorAll('.checkbox[data-action="select"]');

      }
    }

    const selectAll = document.querySelector('#selectAll')
    if (selectAll && !unselected && files.length) {
      selectAll.checked = true
      selectAll.title = 'Unselect all'
    }

    page.fadeInDom()

    const pageNum = files.length ? params.pageNum : 0
    if (params.forceScroll ||
      page.prevPageNums[page.currentView] === null ||
      page.prevPageNums[page.currentView] !== pageNum) {
      const disableSmooth = !params.forceScroll && page.views[page.currentView].type === 'thumbs'
      page.scrollToDom(disableSmooth)
    }

    if (page.views[page.currentView].type === 'thumbs') {
      page.lazyLoad.update()
    }

    page.updateTrigger(params.trigger, 'active')

    page.updateSelectedItems(page.selected[page.currentView].length)

    if (page.currentView === 'uploads') {
      page.views.uploads.album = params.album
    }
    page.views[page.currentView].filters = params.filters
    page.views[page.currentView].pageNum = page.prevPageNums[page.currentView] = pageNum
  }).catch(error => {
    page.updateTrigger(params.trigger)
    page.onAxiosError(error)
  })
}

page.setUploadsView = (view, element) => {
  if (page.isSomethingLoading) return page.warnSomethingLoading()

  if (view === 'list') {
    delete localStorage[lsKeys.viewType[page.currentView]]
    page.views[page.currentView].type = undefined
  } else {
    localStorage[lsKeys.viewType[page.currentView]] = view
    page.views[page.currentView].type = view
  }

  // eslint-disable-next-line compat/compat
  page.getUploads(Object.assign(page.views[page.currentView], {
    trigger: element
  }))
}

page.toggleOriginalNames = element => {
  if (page.isSomethingLoading) return page.warnSomethingLoading()

  if (page.views[page.currentView].originalNames) {
    delete localStorage[lsKeys.originalNames[page.currentView]]
    page.views[page.currentView].originalNames = false
  } else {
    localStorage[lsKeys.originalNames[page.currentView]] = '1'
    page.views[page.currentView].originalNames = true
  }

  // eslint-disable-next-line compat/compat
  page.getUploads(Object.assign(page.views[page.currentView], {
    trigger: element
  }))
}

page.displayPreview = id => {
  const file = page.cache[id]
  console.log(id, file)
  if (!file.previewable) return

  const div = document.createElement('div')
  div.innerHTML = `
    <div class="content has-text-centered">
      <p>
        <div class="has-text-weight-bold">${file.name}</div>
        <div>${file.original}</div>
      </p>
      ${file.thumb
      ? `<p class="swal-display-thumb-container">
        <img id="swalThumb" src="${file.thumb}">
      </p>`
      : ''}
    </div>
  `

  if (file.file && ['picture', 'video', 'audio'].includes(file.type)) {
    div.innerHTML += `
      <div class="field has-text-centered">
        <div class="controls">
          <a id="swalOriginal" type="button" class="button is-info">
            <span class="icon">
              <i class="icon-${file.type}"></i>
            </span>
            <span>${file.type === 'picture' ? 'Load original' : 'Play in embedded player'}</span>
          </a>
        </div>
      </div>
    `

    if (file.type === 'picture') {
      div.querySelector('#swalOriginal').addEventListener('click', event => {
        const trigger = event.currentTarget
        if (trigger.classList.contains('is-danger')) return

        trigger.classList.add('is-loading')
        const thumb = div.querySelector('#swalThumb')

        thumb.src = file.file
        thumb.onload = () => {
          trigger.classList.add('is-hidden')
          document.body.querySelector('.swal-overlay .swal-modal:not(.is-expanded)').classList.add('is-expanded')
        }
        thumb.onerror = event => {
          event.currentTarget.classList.add('is-hidden')
          trigger.className = 'button is-danger is-fullwidth'
          trigger.innerHTML = `
            <span class="icon">
              <i class="icon-block"></i>
            </span>
            <span>Unable to load original</span>
          `
        }
      })
    } else {
      const match = file.file.match(/.*\/(.*)$/)
      if (match || match[1]) {
        div.querySelector('#swalOriginal').setAttribute('href', `v/${match[1]}`)
        div.querySelector('#swalOriginal').setAttribute('target', '_blank')
      }
    }
  }

  return swal({
    content: div,
    buttons: false
  }).then(() => {
    // Restore modal size
    document.body.querySelector('.swal-overlay .swal-modal').classList.remove('is-expanded')
  })
}

page.selectAll = element => {
  for (let i = 0; i < page.checkboxes.length; i++) {
    const id = page.getItemID(page.checkboxes[i])
    if (isNaN(id)) continue
    if (page.checkboxes[i].checked !== element.checked) {
      page.checkboxes[i].checked = element.checked
      if (page.checkboxes[i].checked) {
        page.selected[page.currentView].push(id)
      } else {
        page.selected[page.currentView].splice(page.selected[page.currentView].indexOf(id), 1)
      }
    }
  }

  if (page.selected[page.currentView].length) {
    localStorage[lsKeys.selected[page.currentView]] = JSON.stringify(page.selected[page.currentView])
    page.updateSelectedItems(page.selected[page.currentView].length)
  } else {
    delete localStorage[lsKeys.selected[page.currentView]]
    page.updateSelectedItems(0)
  }

  element.title = element.checked ? 'Unselect all' : 'Select all'
}

page.selectInBetween = (element, lastElement) => {
  const thisIndex = parseInt(element.dataset.index)
  const lastIndex = parseInt(lastElement.dataset.index)

  const distance = Math.abs(thisIndex - lastIndex)
  if (distance < 2) return

  for (let i = 0; i < page.checkboxes.length; i++) {
    if ((thisIndex > lastIndex && i > lastIndex && i < thisIndex) ||
      (thisIndex < lastIndex && i > thisIndex && i < lastIndex)) {
      // Check or uncheck depending on the state of the initial checkbox
      const checked = page.checkboxes[i].checked = lastElement.checked
      const id = page.getItemID(page.checkboxes[i])
      if (!page.selected[page.currentView].includes(id) && checked) {
        page.selected[page.currentView].push(id)
      } else if (page.selected[page.currentView].includes(id) && !checked) {
        page.selected[page.currentView].splice(page.selected[page.currentView].indexOf(id), 1)
      }
    }
  }
}

page.select = (element, event) => {
  const id = page.getItemID(element)
  if (isNaN(id)) return

  if (event.shiftKey && page.lastSelected) {
    page.selectInBetween(element, page.lastSelected)
    // Check or uncheck depending on the state of the initial checkbox
    element.checked = page.lastSelected.checked
  } else {
    page.lastSelected = element
  }

  if (!page.selected[page.currentView].includes(id) && element.checked) {
    page.selected[page.currentView].push(id)
  } else if (page.selected[page.currentView].includes(id) && !element.checked) {
    page.selected[page.currentView].splice(page.selected[page.currentView].indexOf(id), 1)
  }

  // Update local storage
  if (page.selected[page.currentView].length) {
    localStorage[lsKeys.selected[page.currentView]] = JSON.stringify(page.selected[page.currentView])
    page.updateSelectedItems(page.selected[page.currentView].length)
  } else {
    delete localStorage[lsKeys.selected[page.currentView]]
    page.updateSelectedItems(0)
  }
}

page.clearSelection = () => {
  const selected = page.selected[page.currentView]
  const type = page.getByView(page.currentView, 'type')
  const count = selected.length

  if (!count) {
    return swal({
      title: 'An error occurred!',
      text: `You have not selected any ${type}.`,
      icon: 'error',
      className: 'swal-general'
    })
  }

  const suffix = count === 1 ? type.substring(0, type.length - 1) : type
  return swal({
    title: 'Are you sure?',
    text: `You are going to unselect ${count} ${suffix}.`,
    icon: 'info',
    className: 'swal-general',
    // buttons: true
  }).then(proceed => {
    if (!proceed) return

    const checkboxes = page.checkboxes
    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        checkboxes[i].checked = false
      }
    }

    page.selected[page.currentView] = []
    delete localStorage[lsKeys.selected[page.currentView]]

    const selectAll = document.querySelector('#selectAll')
    if (selectAll) selectAll.checked = false

    page.updateSelectedItems(0)

    return swal({
      title: 'Cleared selection!',
      text: `Unselected ${count} ${suffix}.`,
      icon: 'info',
      className: 'swal-general'
    })
  })
}

page.updateSelectedItems = (value) => {
  const selectedItems = document.querySelector('#selectedItems')

  if (value == 0) {
    selectedItems.classList.add('hidden')
    return
  }

  selectedItems.classList.remove('hidden')
  selectedItems.querySelector('.font-bold').innerText = value;
}

page.uploadFiltersHelp = element => {
  const all = Boolean(element.dataset.all)
  const content = document.createElement('div')
  content.style = 'text-align: left'
  content.innerHTML = `${all
    ? `There are 2 filter keys, namely <b>user</b> (username) and <b>ip</b>.
    These keys can be specified more than once.
    For usernames with whitespaces, wrap them with double quotes (<code>"</code>).
    Special cases such as uploads by non-registered users or have no IPs respectively, use <code>user:-</code> or <code>ip:-</code>.

    To exclude certain users/ips while still listing every other uploads, add negation sign (<code>-</code>) before the keys.
    Negation sign can also be used to exclude the special cases mentioned above (i.e. <code>-user:-</code> or <code>-ip:-</code>).

    If you know the ID of a user's album, you can list its uploads with <b>albumid</b> key.
    Negation sign works for this key as well.`
    : `There is only 1 filter key, namely <b>albumid</b>.
    This key can be specified more than once.
    Special case such as uploads with no albums, use <code>albumid:-</code>.

    To exclude certain albums while still listing every other uploads, add negation sign (<code>-</code>) before the keys.
    Negation sign can also be used to exclude the special case mentioned above (i.e. <code>-albumid:-</code>).`}

    There are 2 range keys: <b>date</b> (upload date) and <b>expiry</b> (expiry date).
    Their format is: <code>"YYYY/MM/DD HH:MM:SS-YYYY/MM/DD HH:MM:SS"</code> ("from" date and "to" date respectively).
    You may specify only one of the dates.
    If "to" date is missing, 'now' will be used. If "from" date is missing, 'beginning of time' will be used.
    If any of the subsequent date or time units are not specified, their first value will be used (e.g. January for month, 1 for day, and so on).
    If only time is specified, today's date will be used.
    If you do not need to specify both date and time, you may omit the double quotes.
    In conclusion, the following examples are all valid: <code>date:"2020/01/01 01:23-2018/01/01 06"</code>, <code>expiry:-2020/05</code>, <code>date:12:34:56</code>.
    These keys can only be specified once each.

    <b>Timezone?</b> Feel free to query the dates with your own timezone.
    API requests to the filter endpoint will attach your browser's timezone offset, so the server will automatically calculate timezone differences.

    Matches can also be sorted with <b>sort</b> keys.
    Their formats are: <code>sort:columnName[:d[escending]]</code>, where <code>:d[escending]</code> is an optional tag to set the direction to descending.
    This key must be used with internal column names used in the database (<code>id</code>, <code>${all ? 'userid' : 'albumid'}</code>, and so on),
    but there are 2 shortcuts available: <b>date</b> for <code>timestamp</code> column and <b>expiry</b> for <code>expirydate</code> column.
    This key can also be specified more than once, where their order will decide the sorting steps.

    Finally, there are type-<b>is</b> keys to refine by types.
    You can use <code>is:image</code>, <code>is:video</code>, and <code>is:audio</code> to list images, videos, audios respectively.
    This will only use image, video and audio extensions that are whitelisted internally in the safe.
    For images and videos specifically, they will be the ones whose thumbnails can be generated by the safe.
    Negation sign works for this key as well.
    Mixing inclusion and exclusion is not allowed (i.e. <code>is:image -is:video</code>, since the second key is redundant).

    Any leftover keywords which do not use keys (non-keyed keywords) will be matched against the matches' file names.
    Excluding certain keywords is also supported by adding negation sign before the keywords.

    <b>Internal steps:</b>
    ${all
      ? `- Query uploads passing ALL exclusion filter keys OR matching ANY filter keys, if any.
    - Refine matches`
      : '- Filter uploads'} using date key, if any.
    - Refine matches using expiry key, if any.
    - Refine matches using type-is keys, if any.
    - Refine matches using ANY non-keyed keywords, if any.
    - Filter matches using ALL exclusion non-keyed keywords, if any.
    - Sort matches using sorting keys, if any.

    <b>Examples:</b>
    ${all
      ? `- Uploads from users named "demo" AND/OR "John Doe" AND/OR non-registered users:
    <code>user:demo user:"John Doe" user:-</code>
    - ALL uploads, but NOT the ones from user named "demo" AND "John Doe":
    <code>-user:demo -user:"John Doe"</code>
    - Uploads from IP "127.0.0.1" AND which file names match "*.rar" OR "*.zip":
    <code>ip:127.0.0.1 *.rar *.zip</code>
    `
      : ''}- Uploads without albums:
    <code>albumid:-</code>
    - ALL uploads, but NOT the ones from album with ID 69:
    <code>-albumid:69</code>
    - Uploads uploaded since "1 June 2019 00:00:00":
    <code>date:2019/06</code>
    - Uploads uploaded between "7 April 2020 12:00:00" and "7 April 2020 23:59:59":
    <code>date:"2020/04/07 12-2020/04/07 23:59:59"</code>
    - Uploads uploaded before "5 February 2020 00:00:00":
    <code>date:-2020/02/05</code>
    - Uploads which file names match "*.gz" but NOT "*.tar.gz":
    <code>*.gz -*.tar.gz</code>
    - Sort matches by "size" column in ascending and descending order respectively:
    <code>${all ? 'user:"John Doe"' : '*.txt'} sort:size</code>
    <code>*.mp4 ${all ? 'user:- ' : ''}sort:size:d</code>
    ${!page.permissions.moderator
      ? '<b>Notice:</b> Regular users may face some limitations in the amount of keys that can be used at a time.'
      : ''}
    <b>Friendly reminder:</b> This window can be scrolled up!
  `.trim().replace(/^\s*/g, '').replace(/\n/g, '<br>')

  swal({ content }).then(() => {
    // Restore modal size
    document.body.querySelector('.swal-overlay .swal-modal').classList.remove('is-expanded')
  })

  // Expand modal size
  document.body.querySelector('.swal-overlay .swal-modal:not(.is-expanded)').classList.add('is-expanded')
}

page.filterUploads = element => {
  const filters = document.querySelector(`#${element.dataset.filtersid || 'filters'}`).value
    .trim()
    .replace(/\t/g, ' ')
    .replace(/(^|\s)((albumid|ip|user|date|expiry|is|sort|orderby):)\s+/g, '$2')
  // eslint-disable-next-line compat/compat
  page.getUploads(Object.assign(page.views[page.currentView], {
    filters,
    pageNum: 0,
    trigger: element
  }))
}

page.filterAlbums = element => {
  const filters = document.querySelector(`#${element.dataset.filtersid || 'filters'}`).value
    .trim()
    .replace(/\t/g, ' ')
    .replace(/(^|\s)((albumid|ip|user|date|expiry|is|sort|orderby):)\s+/g, '$2')
  // eslint-disable-next-line compat/compat
  page.getAlbums(Object.assign(page.views[page.currentView], {
    filters,
    pageNum: 0,
    trigger: element
  }))
}

page.viewUserUploads = (id, element) => {
  const user = page.cache[id]
  if (!user) return
  element.classList.add('is-loading')
  // Wrap username in quotes if it contains whitespaces
  const username = user.username.includes(' ')
    ? `"${user.username}"`
    : user.username
  page.getUploads({
    all: true,
    filters: `user:${username}`,
    trigger: document.querySelector('#itemManageUploads')
  })
}

page.viewAlbumUploads = (id, element) => {
  if (!page.cache[id]) return;
  element.classList.add('is-loading');
  
  const all = page.currentView === 'albumsAll';
  const albumHTML = `
      <div class="bg-mute border border-line p-4 rounded-lg flex flex-wrap justify-between gap-4">
        <div class="flex gap-3 items-center">
          <span class="btn btn-main-light btn-sm text-xs font-semibold" type="button">Album Actions (coming soon)</span>
        </div>
        <div class="flex gap-2 w-full flex-wrap sm:w-auto">
          <button class="btn btn-seco-outline btn-sm text-xs gap-1 font-semibold ic-trash-01 ic-before before:text-base flex-1 max-[374px]:flex-none max-[374px]:w-full sm:flex-none" type="button" data-action="album-purge-cache" disabled>Purge cache</button>
        </div>
      </div>
    `;

  // Flag to ensure we only add the HTML once
  let htmlAdded = false;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0 && !htmlAdded) {
        const selectedDiv = document.querySelector('div.selected');
        if (selectedDiv) {
          selectedDiv.insertAdjacentHTML('beforebegin', albumHTML);
          htmlAdded = true; // Set flag to true
          observer.disconnect(); // Stop observing once we've made the insertion
        }
      }
    });
  });

  // Start observing the target node for configured mutations
  observer.observe(document.getElementById('page'), { childList: true, subtree: true });

  page.getUploads({
    all,
    filters: `albumid:${id}`,
    trigger: all
      ? document.querySelector('#itemManageUploads')
      : document.querySelector('#itemUploads')
  });
};

page.deleteUpload = id => {
  page.postBulkDeleteUploads({
    all: page.currentView === 'uploadsAll',
    field: 'id',
    values: [id],
    cb(failed) {
      // Remove from remembered checkboxes if necessary
      if (!failed.length && page.selected[page.currentView].includes(id)) {
        page.selected[page.currentView].splice(page.selected[page.currentView].indexOf(id), 1)
      }

      // Update local storage
      if (page.selected[page.currentView].length) {
        localStorage[lsKeys.selected[page.currentView]] = JSON.stringify(page.selected[page.currentView])
      } else {
        delete localStorage[lsKeys.selected[page.currentView]]
      }

      // Reload upload list
      // eslint-disable-next-line compat/compat
      page.getUploads(Object.assign(page.views[page.currentView], {
        autoPage: true
      }))
    }
  })
}

page.bulkDeleteUploads = () => {
  const count = page.selected[page.currentView].length
  if (!count) return swal('An error occurred!', 'You have not selected any uploads.', 'error')

  page.postBulkDeleteUploads({
    all: page.currentView === 'uploadsAll',
    field: 'id',
    values: page.selected[page.currentView],
    cb(failed) {
      // Update state of checkboxes
      if (failed.length) {
        page.selected[page.currentView] = page.selected[page.currentView]
          .filter(id => failed.includes(id))
      } else {
        page.selected[page.currentView] = []
      }

      // Update local storage
      if (page.selected[page.currentView].length) {
        localStorage[lsKeys.selected[page.currentView]] = JSON.stringify(page.selected[page.currentView])
      } else {
        delete localStorage[lsKeys.selected[page.currentView]]
      }

      // Reload uploads list
      // eslint-disable-next-line compat/compat
      page.getUploads(Object.assign(page.views[page.currentView], {
        autoPage: true
      }))
    }
  })
}

page.postBulkDeleteUploads = (params = {}) => {
  const count = params.values.length;

  const objective = `${params.values.length} upload${count === 1 ? '' : 's'}`;
  const boldObjective = objective.replace(/^(\d*)(.*)/, '<b>$1</b>$2>');
  let text = `<p>You won't be able to recover ${boldObjective}!</p>`;

  if (params.all) {
    const obj1 = count === 1 ? 'an upload' : 'some uploads';
    const obj2 = count === 1 ? 'another user' : 'other users';
    text += `\n<p><b>Warning:</b> You may be nuking ${obj1} by ${obj2}!</p>`;
  }

  const content = document.createElement('div');
  content.innerHTML = `
  <div class="bg-back/80-xxx fixed-xxx inset-0 w-full-xxx h-full-xxx z-50 place-items-end pt-0 sm:p-12-xxx sm:place-items-center [&.show]:grid show">
    <div class="bg-mute p-4 w-full rounded-t-xl max-h-full-xxx grid auto-rows-max gap-6 overflow-auto sm:rounded-lg sm:max-w-lg sm:p-8-xxx">
      <div class="grid auto-rows-max gap-4 relative place-items-center text-center py-6">
        <button class="btn btn-seco-ghost text-xl absolute end-0 top-0 p-0 -m-2 sm:-m-4" type="button" aria-label="Close">
          <span class="ic-x-close"></span>
        </button>
        <span class="ic-alert-circle w-24 h-24 ic-before before:text-5xl text-fire bg-fire/10 rounded-full grid place-content-center"></span>
        <div class="text-3xl font-bold text-lead font-cabinet">Are you sure?</div>
        <div class="text-base">You won't be able to recover ${count} upload${count === 1 ? '' : 's'}!</div>
      </div>
    </div>
  </div>
  `;

  swal({
    icon: '',
    content,
    className: '',
    dangerMode: true,
    buttons: {
      cancel: {
        text: 'Cancel',
        visible: true,
        className: 'btn btn-lg btn-seco font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full max-[425px]:order-last" type="button',
      },
      fire: {
        text: `Yes, nuke ${params.values.length === 1 ? 'it' : 'them'}!`,
        className: 'btn btn-lg btn-fire font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full',
        closeModal: false,
      },
    },
  }).then(proceed => {
    if (!proceed) return;

    const payload = {
      field: params.field,
      values: params.values,
      deleted_date: new Date().toISOString(), // ISO date format
    };

    if (page.permissions.admin) {
      // Show input for moderators to specify a reason
      swal({
        title: 'Specify Reason for Deletion',
        content: {
          element: 'input',
          attributes: {
            placeholder: 'Enter reason for deletion',
            type: 'text',
          },
        },
        buttons: {
          cancel: 'Cancel',
          confirm: 'Submit',
        },
        closeOnClickOutside: false,
      }).then(reason => {
        if (reason) {
          payload.deleted_reason = reason;
          proceedWithDeletion(payload, objective, count, params.cb);
        }
      });
    } else {
      // Use default reason for non-moderators
      payload.deleted_reason = 'User deleted the file';
      proceedWithDeletion(payload, objective, count, params.cb);
    }
  });

  function proceedWithDeletion(payload, objective, count, callback) {
    axios.post('api/upload/bulkdelete', payload)
      .then(response => {
        if (!response) return;

        if (response.data.success === false) {
          if (response.data.description === 'No token provided') {
            return page.verifyToken(page.token);
          } else {
            return swal('An error occurred!', response.data.description, 'error');
          }
        }

        const failed = Array.isArray(response.data.failed) ? response.data.failed : [];
        if (failed.length === count) {
          swal('An error occurred!', `Unable to delete any of the ${objective}.`, 'error');
        } else if (failed.length && failed.length < count) {
          swal('Warning!', `From ${objective}, unable to delete ${failed.length} of them.`, 'warning');
        } else {
          swal('Deleted!', `${objective} ${count === 1 ? 'has' : 'have'} been deleted.`, 'success', {
            buttons: false,
            timer: 1500,
          });
        }

        if (typeof callback === 'function') callback(failed);
      })
      .catch(page.onAxiosError);
  }
};


page.postBulkDeleteUploads = (params = {}) => {
  const count = params.values.length;

  const objective = `${params.values.length} upload${count === 1 ? '' : 's'}`;
  const boldObjective = objective.replace(/^(\d*)(.*)/, '<b>$1</b>$2');
  let text = `<p>You won't be able to recover ${boldObjective}!</p>`;

  if (params.all) {
    const obj1 = count === 1 ? 'an upload' : 'some uploads';
    const obj2 = count === 1 ? 'another user' : 'other users';
    text += `\n<p><b>Warning:</b> You may be nuking ${obj1} by ${obj2}!</p>`;
  }

  const content = document.createElement('div');
  content.innerHTML = `
  <div class="bg-back/80-xxx fixed-xxx inset-0 w-full-xxx h-full-xxx z-50 place-items-end pt-0 sm:p-12-xxx sm:place-items-center [&.show]:grid show">
    <div class="bg-mute p-4 w-full rounded-t-xl max-h-full-xxx grid auto-rows-max gap-6 overflow-auto sm:rounded-lg sm:max-w-lg sm:p-8-xxx">
      <div class="grid auto-rows-max gap-4 relative place-items-center text-center py-6">
        <button class="btn btn-seco-ghost text-xl absolute end-0 top-0 p-0 -m-2 sm:-m-4" type="button" aria-label="Close">
          <span class="ic-x-close"></span>
        </button>
        <span class="ic-alert-circle w-24 h-24 ic-before before:text-5xl text-fire bg-fire/10 rounded-full grid place-content-center"></span>
        <div class="text-3xl font-bold text-lead font-cabinet">Are you sure?</div>
        <div class="text-base">You won't be able to recover ${count} upload${count === 1 ? '' : 's'}!</div>
      </div>
    </div>
  </div>
  `;

  swal({
    icon: '',
    content,
    className: '',
    dangerMode: true,
    buttons: {
      cancel: {
        text: 'Cancel',
        visible: true,
        className: 'btn btn-lg btn-seco font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full max-[425px]:order-last" type="button',
      },
      fire: {
        text: `Yes, nuke ${params.values.length === 1 ? 'it' : 'them'}!`,
        className: 'btn btn-lg btn-fire font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full',
        closeModal: false,
      },
    },
  }).then(proceed => {
    if (!proceed) return;

    let payload = {
      field: params.field,
      values: params.values,
      deleted_reason: 'User deleted the file',
      deleted_date: new Date().toISOString(), // ISO date format
    };

    // Check if the user is a moderator
    if (page.permissions.moderator) {
      // Prompt for a reason if the user is a moderator
      swal({
        title: 'Specify Reason for Deletion',
        content: {
          element: "input",
          attributes: {
            placeholder: "Enter reason for deletion",
            type: "text",
          },
        },
        buttons: {
          cancel: 'Cancel',
          confirm: 'Submit'
        }
      }).then((value) => {
        if (value) {
          payload.deleted_reason = value || 'No reason specified by moderator';
          // Proceed with the deletion using the specified reason
          return axios.post('api/upload/bulkdelete', payload);
        } else {
          // User cancelled the reason input, close the modal and do nothing
          swal.close();
          return Promise.reject(new Error('Deletion cancelled by user.'));
        }
      }).then(response => {
        handleResponse(response, objective, count, params.cb);
      }).catch(page.onAxiosError);
    } else {
      // If not a moderator, send the payload without prompting for a reason
      axios.post('api/upload/bulkdelete', payload)
        .then(response => handleResponse(response, objective, count, params.cb))
        .catch(page.onAxiosError);
    }
  });
};

// Helper function to handle responses uniformly
function handleResponse(response, objective, count, cb) {
  if (!response) return;

  if (response.data.success === false) {
    if (response.data.description === 'No token provided') {
      return page.verifyToken(page.token);
    } else {
      return swal('An error occurred!', response.data.description, 'error');
    }
  }

  const failed = Array.isArray(response.data.failed) ? response.data.failed : [];
  if (failed.length === count) {
    swal('An error occurred!', `Unable to delete any of the ${objective}.`, 'error');
  } else if (failed.length && failed.length < count) {
    swal('Warning!', `From ${objective}, unable to delete ${failed.length} of them.`, 'warning');
  } else {
    swal('Deleted!', `${objective} ${count === 1 ? 'has' : 'have'} been deleted.`, 'success', {
      buttons: false,
      timer: 1500,
    });
  }

  if (typeof cb === 'function') cb(failed);
}


page.addSelectedUploadsToAlbum = () => {
  if (page.currentView !== 'uploads') return

  const count = page.selected[page.currentView].length
  if (!count) {
    return swal({
      title: 'An error occurred!',
      text: 'You have not selected any uploads.',
      icon: 'error',
      className: 'swal-general'
    })
  }

  page.addUploadsToAlbum(page.selected[page.currentView], failed => {
    if (!failed) return
    if (failed.length) {
      page.selected[page.currentView] = page.selected[page.currentView]
        .filter(id => failed.includes(id))
    } else {
      page.selected[page.currentView] = []
    }

    localStorage[lsKeys.selected[page.currentView]] = JSON.stringify(page.selected[page.currentView])
    page.getUploads(page.views[page.currentView])
  })
}

page.addToAlbum = id => {
  page.addUploadsToAlbum([id], failed => {
    if (!failed) return
    page.getUploads(page.views[page.currentView])
  })
}

page.addUploadsToAlbum = (ids, callback) => {
  const count = ids.length

  const content = document.createElement('div')
  content.innerHTML = `
    <div class="bg-back/80-xxx fixed-xxx inset-0 w-full-xxx h-full-xxx z-50 place-items-end pt-0 sm:p-12-xxx sm:place-items-center [&.show]:grid show">
      <div class="bg-mute p-4 w-full rounded-t-xl max-h-full grid auto-rows-max gap-6 overflow-auto sm:rounded-lg sm:max-w-lg sm:p-4">
        <div class="grid auto-rows-max gap-4 relative place-items-center text-center py-6">
          <button class="btn btn-seco-ghost text-xl absolute end-0 top-0 p-0 -m-2 sm:-m-4" type="button" aria-label="Close">
            <span class="ic-x-close"></span>
          </button>
          <span class="ic-info-circle w-24 h-24 ic-before before:text-5xl text-info bg-info/10 rounded-full grid place-content-center"></span>
          <div class="text-3xl font-bold text-lead font-cabinet">Are you sure?</div>
          <div class="text-base">You are about to add <span class="font-bold">${count}</span> upload${count === 1 ? '' : 's'} to an album.</div>
          <div class="text-xs -mt-2">If an upload is already in an album, it will be moved.</div>
        </div>
        <!-- album -->
        <div class="ic-folder ic-before before:absolute before:text-lg before:start-4 before:top-3.5 before:opacity-60 before:pointer-events-none relative flex-1">
          <label class="sr-only" for="swalAlbum">Choose an album</label>
          <select id="swalAlbum" name="swalAlbum" class="bg-body ps-11" disabled>
            <option value="-1">Remove from album</option>
            <option value="" selected disabled>Fetching albums list\u2026</option>
          </select>
        </div>
      </div>
    </div>
  `

  swal({
    icon: '',
    content,
    className: 'swal-confirm-form',
    buttons: {
      cancel: {
        text: 'Cancel',
        className: "btn btn-lg btn-seco font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full max-[425px]:order-last",
        visible: true,
        closeModal: true,
      },
      info: {
        text: 'OK',
        className: "btn btn-lg btn-info font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full",
        closeModal: true
      }
    }
  }).then(choose => {
    if (!choose) return

    const albumid = parseInt(document.querySelector('#swalAlbum').value)
    if (isNaN(albumid)) {
      return swal({
        title: 'An error occurred!',
        text: 'You did not choose an album.',
        className: 'swal-general',
        icon: 'error'
      })
    }

    axios.post('api/albums/addfiles', {
      ids,
      albumid
    }).then(add => {
      if (!add) return

      if (add.data.success === false) {
        if (add.data.description === 'No token provided') {
          page.verifyToken(page.token)
        } else {
          swal('An error occurred!', add.data.description, 'error')
        }
        return
      }

      let added = ids.length
      if (add.data.failed && add.data.failed.length) {
        added -= add.data.failed.length
      }

      const suffix = `upload${ids.length === 1 ? '' : 's'}`
      if (!added) {
        return swal({
          title: 'An error occurred!',
          text: `Could not add the ${suffix} to the album.`,
          icon: 'error'
        })
      }

      swal({
        title: 'Woohoo!',
        text: `Successfully ${albumid < 0 ? 'removed' : 'added'} ${added} ${suffix} ${albumid < 0 ? 'from' : 'to'} the album.`,
        icon: 'info',
        buttons: {
          cancel: false,
          confirm: {
            text: 'OK',
            closeModal: false
          }
        },
        timer: 1500
      })
      callback(add.data.failed)
    }).catch(page.onAxiosError)
  })

  // Get albums list then update content of swal
  axios.get('api/albums', { headers: { simple: '1' } }).then(list => {
    if (list.data.success === false) {
      if (list.data.description === 'No token provided') {
        page.verifyToken(page.token)
      } else {
        swal('An error occurred!', list.data.description, 'error')
      }
      return
    }
  
    // If the prompt was replaced, the container would be missing
    const select = document.querySelector('#swalAlbum')
    if (!select) return
  
    // Sort albums alphabetically by their name
    const sortedAlbums = list.data.albums.sort((a, b) => a.name.localeCompare(b.name))
  
    select.innerHTML += sortedAlbums
      .map(album => `<option value="${album.id}">${album.name}</option>`)
      .join('\n')
  
    // Update the first option's text and enable the select element
    select.getElementsByTagName('option')[1].innerHTML = 'Choose an album'
    select.removeAttribute('disabled')
  }).catch(page.onAxiosError)
  
}

page.getAlbums = (params = {}) => {
  if (params && params.all && !page.permissions.moderator) {
    return swal('An error occurred!', 'You cannot do this!', 'error')
  }

  if (page.isSomethingLoading) return page.warnSomethingLoading()

  page.updateTrigger(params.trigger, 'loading')

  if (typeof params.pageNum !== 'number') params.pageNum = 0

  const headers = {}
  if (params.all) headers.all = '1'
  if (params.filters) {
    headers.filters = params.filters
    // Send client timezone offset if properly using date: and/or :expiry filters
    // Server will pretend client is on UTC if unset
    if (/(^|\s)(date|expiry):[\d"]/.test(params.filters)) {
      headers.minoffset = new Date().getTimezoneOffset()
    }
  }

  const url = `api/albums/${params.pageNum}`
  axios.get(url, { headers }).then(response => {
    if (!response) return

    if (response.data.success === false) {
      if (response.data.description === 'No token provided') {
        return page.verifyToken(page.token)
      } else {
        page.updateTrigger(params.trigger)
        return swal('An error occurred!', response.data.description, 'error')
      }
    }

    // const pages = Math.ceil(response.data.count / 50)
    // const albums = response.data.albums
    // if (params.pageNum !== undefined && albums.length === 0) {
    //   page.updateTrigger(params.trigger)
    //   if (params.autoPage) {
    //     params.pageNum = pages - 1
    //     return page.getAlbums(params)
    //   } else {
    //     return swal('An error occurred!', `There are no more albums to populate page ${params.pageNum + 1}.`, 'error')
    //   }
    // }

    const pages = Math.ceil(response.data.count / 50)
    const albums = response.data.albums
    if (params.pageNum && (albums.length === 0)) {
      page.updateTrigger(params.trigger)
      if (params.autoPage) {
        params.pageNum = pages - 1
        return page.getAlbums(params)
      } else {
        return swal('An error occurred!', `There are no more albums to populate page ${params.pageNum + 1}.`, 'error')
      }
    }

    // console.log('pageNum:', params.pageNum)
    // console.log('Albums length:', albums.length)
    // console.log('Pages:', pages)
    // console.log('autoPage:', params.autoPage)

    page.currentView = params.all ? 'albumsAll' : 'albums'
    page.cache = {}

    const users = response.data.users
    const homeDomain = response.data.homeDomain

    if (params.pageNum < 0) params.pageNum = Math.max(0, pages + params.pageNum)
    const pagination = page.paginate(response.data.count, 50, params.pageNum)
    const hasFilter = page.escape(params.filters || '') ? true : false

    const createAlbumsFilter = `
      <!-- modal -->
        <!-- add class "show" to see -->
        <div id="createAlbumsFilter" class="bg-back/80 fixed inset-0 w-full h-full z-50 place-items-end sm:place-items-center hidden [&.show]:grid hidden">
          <div class="bg-mute p-4 w-full rounded-t-xl max-h-full grid auto-rows-max gap-6 overflow-auto sm:rounded-lg sm:max-w-3xl sm:p-8">
            <div class="grid auto-rows-max gap-4 relative">
              <button class="btn btn-seco-ghost text-xl absolute end-0 top-0 p-0 -m-2 sm:-m-4" type="button" aria-label="Close" data-action="close-modal">
                <span class="ic-x-close"></span>
              </button>
              <!-- <span class="ic-folder w-12 h-12 ic-before before:text-2xl text-main bg-main/10 rounded-full grid place-content-center"></span> -->
              <div class="text-2xl font-bold text-subs font-cabinet">Filter Albums</div>
            </div>
            <div class="grid auto-rows-max gap-4">
              <form class="prevent-default">
              <div class="grid auto-rows-max gap-1">
                <label class="font-semibold text-subs sr-only" for="filters">Name</label>
                <input class="bg-body sm:text-sm" type="text" id="filters" placeholder="Filter Albums" value="${page.escape(params.filters || '')}">
                <button type="submit" class="button is-small is-info is-outlined hidden" title="Filter albums" data-action="filter-albums">
                  <span class="icon">
                    <i class="icon-filter"></i>
                  </span>
                </button>
                <p class="text-xs mt-1">Press <span class="font-semibold">ENTER</span> to filter</p>
              </div>
              </form>
            </div>
            <div class="bg-body border-t border-line p-4 sm:rounded-b-xl -m-4 mt-0 sm:-m-8 sm:mt-0 sm:p-8">
              <details class="group/item">
                <summary class="flex gap-3 cursor-pointer group-open/item:mb-4 sm:group-open/item:mb-8 sticky top-0 bg-body before:bg-body before:absolute before:-inset-4 sm:before:-inset-8 before:-z-10 select-none">
                  <span class="ic-help-circle text-xl text-main" aria-hidden="true"></span>
                  <div class="flex-1 grid auto-rows-max gap-1">
                    <span class="text-main">Sort list</span>
                    <span class="text-xs">Everything you need to know about filters.</span>
                  </div>
                  <span class="btn btn-main-light rounded-full p-0 ic-chevron-right ic-before text-lg rotate-90 group-open/item:-rotate-90" aria-hidden="true"></span>
                </summary>
                <div class="entry bg-mute border border-soft p-4 rounded-lg">
                  <p>There is only 1 filter key, namely <strong>albumid</strong>.<br> This key can be specified more than once.<br> Special case such as uploads with no albums, use <code class="inline-block">albumid:-</code>.
                  </p>
        
                  <p>To exclude certain albums while still listing every other uploads, add negation sign <code class="inline-block">(-)</code> before the keys.<br> Negation sign can also be used to exclude the special case mentioned above <code class="inline-block">(i.e. -albumid:-)</code>.</p>
        
                  <p>There are 2 range keys: <strong>date</strong> (upload date) and <strong>expiry</strong> (expiry date).<br> Their format is: <code class="inline-block">"YYYY/MM/DD HH:MM:SS-YYYY/MM/DD HH:MM:SS"</code> ("from" date and "to" date respectively).<br> You may specify only one of the dates.<br> If "to" date is missing, 'now' will be used. If "from" date is missing, 'beginning of time' will be used.<br> If any of the subsequent date or time units are not specified, their first value will be used (e.g. January for month, 1 for day, and so on).<br> If only time is specified, today's date will be used.<br> If you do not need to specify both date and time, you may omit the double quotes.<br> In conclusion, the following examples are all valid: <code class="inline-block">date:"2020/01/01 01:23-2018/01/01 06"</code>, <code class="inline-block">expiry:-2020/05</code>, <code class="inline-block">date:12:34:56</code>.<br> These keys can only be specified once each.</p>
        
                  <p><strong>Timezone?</strong> Feel free to query the dates with your own timezone.<br> API requests to the filter endpoint will attach your browser's timezone offset, so the server will automatically calculate timezone differences.</p>
        
                  <p>Matches can also be sorted with <strong>sort</strong> keys.<br> Their formats are: <code class="inline-block">sort:columnName[:d[escending]]</code>, where <code class="inline-block">:d[escending]</code> is an optional tag to set the direction to descending.<br> This key must be used with internal column names used in the database (<code class="inline-block">id</code>, <code class="inline-block">albumid</code>, and so on), but there are 2 shortcuts available: date for <code class="inline-block">timestamp</code> column and expiry for <code class="inline-block">expirydate</code> column.<br> This key can also be specified more than once, where their order will decide the sorting steps.</p>
        
                  <p>Finally, there are type-<strong>is</strong> keys to refine by types.<br> You can use <code class="inline-block">is:image</code>, <code class="inline-block">is:video</code>, and <code class="inline-block">is:audio</code> to list images, videos, audios respectively.<br> This will only use image, video and audio extensions that are whitelisted internally in the safe.<br> For images and videos specifically, they will be the ones whose thumbnails can be generated by the safe.<br> Negation sign works for this key as well.<br> Mixing inclusion and exclusion is not allowed (i.e. <code class="inline-block">is:image -is:video</code>, since the second key is redundant).</p>
        
                  <p>Any leftover keywords which do not use keys (non-keyed keywords) will be matched against the matches' file names.<br> Excluding certain keywords is also supported by adding negation sign before the keywords.</p>
        
                  <h4>Internal steps:</h4>
                  <ul>
                    <li>Filter uploads using date key, if any.</li>
                    <li>Refine matches using expiry key, if any.</li>
                    <li>Refine matches using type-is keys, if any.</li>
                    <li>Refine matches using ANY non-keyed keywords, if any.</li>
                    <li>Filter matches using ALL exclusion non-keyed keywords, if any.</li>
                    <li>Sort matches using sorting keys, if any.</li>
                  </ul>
        
                  <h4>Examples:</h4>
                  <ul>
                    <li>
                      Uploads without albums:<br>
                      <code class="inline-block">albumid:-</code>
                    </li>
                    <li>
                      ALL uploads, but NOT the ones from album with ID 69:<br>
                      <code class="inline-block">-albumid:69</code>
                    </li>
                    <li>
                      Uploads uploaded since "1 June 2019 00:00:00":<br>
                      <code class="inline-block">date:2019/06</code>
                    </li>
                    <li>
                      Uploads uploaded between "7 April 2020 12:00:00" and "7 April 2020 23:59:59":<br>
                      <code class="inline-block">date:"2020/04/07 12-2020/04/07 23:59:59"</code>
                    </li>
                    <li>
                      Uploads uploaded before "5 February 2020 00:00:00":<br>
                      <code class="inline-block">date:-2020/02/05</code>
                    </li>
                    <li>
                      Uploads which file names match "*.gz" but NOT "*.tar.gz":<br>
                      <code class="inline-block">*.gz -*.tar.gz</code>
                    </li>
                    <li>
                      Sort matches by "size" column in ascending and descending order respectively:<br>
                      <code class="inline-block">*.txt sort:size</code><br>
                      <code class="inline-block">*.mp4 sort:size:d</code>
                    </li>
                  </ul>
        
                  <p><strong>Friendly reminder:</strong> This window can be scrolled up!</p>
                </div>
              </details>
            </div>
          </div>
        </div>
    `

    // const controls = `
    //   <div class="columns">
    //     <div class="column is-hidden-mobile"></div>
    //     <div class="column bulk-operations has-text-right">
    //       <a class="button is-small is-info is-outlined" title="Clear selection" data-action="clear-selection">
    //         <span class="icon">
    //           <i class="icon-cancel"></i>
    //         </span>
    //       </a>
    //       <a class="button is-small is-dangerish is-outlined" title="Bulk disable (WIP)" data-action="bulk-disable-albums" disabled>
    //         <span class="icon">
    //           <i class="icon-cancel"></i>
    //         </span>
    //         ${!params.all ? '<span>Bulk disable</span>' : ''}
    //       </a>
    //       ${params.all
    //     ? `<a class="button is-small is-danger is-outlined" title="Bulk delete (WIP)" data-action="bulk-delete-albums" disabled>
    //             <span class="icon">
    //               <i class="icon-trash"></i>
    //             </span>
    //             <span>Bulk delete</span>
    //           </a>`
    //     : ''}
    //     </div>
    //   </div>
    // `

    // Whether there are any unselected items
    let unselected = false

    const createNewAlbum = `
      <!-- modal -->
      <!-- add class "show" to see -->
      <div id="createNewAlbum" class="bg-back/80 fixed inset-0 w-full h-full z-50 place-items-end pt-12 sm:p-12 sm:place-items-center hidden [&.show]:grid hidden">
        <div class="bg-mute p-4 w-full rounded-t-xl max-h-full grid auto-rows-max gap-6 overflow-auto sm:rounded-lg sm:max-w-md sm:p-8">
          <form class="prevent-default">
            <div class="grid auto-rows-max gap-4 relative">
              <button class="btn btn-seco-ghost text-xl absolute end-0 top-0 p-0 -m-2 sm:-m-4" type="button" aria-label="Close" data-action="close-modal">
                <span class="ic-x-close"></span>
              </button>
              <span class="ic-folder-plus w-12 h-12 ic-before before:text-2xl text-main bg-main/10 rounded-full grid place-content-center"></span>
              <div class="text-2xl font-bold text-subs font-cabinet">Create new album</div>
            </div>
            <div class="grid auto-rows-max gap-4">
              <div class="grid auto-rows-max gap-1">
                <label class="font-semibold text-subs" for="albumName">Name</label>
                <input class="bg-body sm:text-sm" type="text" id="albumName" maxlength="${page.albumTitleMaxLength}">
                <p class="text-xs mt-1">Max length is ${page.albumTitleMaxLength} characters.</p>
              </div>
              <div class="grid auto-rows-max gap-1">
                <label class="font-semibold text-subs" for="albumDescription">Description</label>
                <textarea class="bg-body" name="albumDescription" id="albumDescription" cols="30" rows="10" maxlength="${page.albumDescMaxLength}"></textarea>
                <p class="text-xs mt-1">Max length is ${page.albumDescMaxLength} characters.</p>
              </div>
              <div class="flex gap-4">
                <button class="btn btn-lg btn-main font-semibold flex-1" type="submit" id="submitAlbum" data-action="submit-album">Create</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    `

    const title = `
      <div class="flex items-center gap-3 flex-wrap">
				<h1 class="font-cabinet text-2xl text-lead py-0.5">Manage your albums</h1>
				<button class="btn btn-wins-light-outline rounded-full font-bold" type="button" data-action="new-album">Create new album <span class="ic-folder-plus text-xl"></span></button>
			</div>
    `

    const options = `
      <!-- options -->
      <div class="flex gap-2 items-center flex-wrap">
        <button class="btn btn-seco-ghost text-text rounded-lg [&.on]:bg-body [&.on]:text-subs ${hasFilter ? 'on' : ''}" type="button" data-action="manage-album-filter">
          <span class="ic-filter-lines text-lg" aria-hidden="true"></span> Filter
        </button>
      </div>
    `

    const navBar = `
      <div class="grid auto-rows-max gap-4">
        <!-- top -->
        <div class="flex items-center justify-between flex-wrap gap-4">
        ${options}
        ${pagination}
      </div>
    `

    const selected = `
    <!-- selected -->
    <div class="bg-mute border border-line p-4 rounded-lg flex flex-wrap justify-between gap-4">
      <div class="flex gap-3 items-center">
        <span id="selectedItems" class="hidden"><span class="font-bold">2</span> selected</span>
        <button class="btn btn-main-light btn-sm text-xs font-semibold" type="button" data-action="clear-selection">Clear selection</button>        
      </div>
      <div class="flex gap-2 w-full flex-wrap sm:w-auto"></div>
    </div>
    `

    // Do some string replacements for bottom controls
    const bottomNavBar = navBar
      .replace(/for="navMySelect"/, `for="bottomNavMySelect"`)
      .replace(/id="navMySelect"/, `id="bottomNavMySelect"`)

    page.dom.innerHTML = `
      ${page.dashboard.openMain}
      ${title}
      ${navBar}
      ${selected}
      <!-- table -->
			<!-- add class "grid-view" to show the grid view and "original-name" to show/hidde that column -->
      <div class="overflow-x-auto border border-line -mx-6 lg:rounded-lg lg:mx-0 max-[375px]:-mx-4 [&.grid-view]:border-0 [&.grid-view]:overflow-visible [&.grid-view]:m-0">
        <div class="inline-block min-w-full align-top">
          <table class="min-w-full divide-y divide-line [.grid-view_&]:grid [.grid-view_&]:divide-y-0">
            <thead class="[.grid-view_&]:hidden">
              <tr>
                <th scope="col" class="px-4 py-3.5 pe-0 w-9 whitespace-nowrap text-start font-semibold relative">
                  <input id="selectAll" class="checkbox bg-body" type="checkbox" title="Unselect all" data-action="select-all">
                </th>
                <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">ID</th>
                <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Name</th>
                <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Views</th>
                <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Upload</th>
                <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Size</th>
                <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Created at</th>
                <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Public link</th>
                <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-end font-semibold">${response.data.count} total</th>
              </tr>
            </thead>
            <tbody id="table" class="divide-y divide-line [.grid-view_&]:grid [.grid-view_&]:gap-4 [.grid-view_&]:divide-y-0 [.grid-view_&]:grid-cols-repeat [.grid-view_&]:[--size:14rem]">
            </tbody>
          </table>
        </div>
      </div>
      ${bottomNavBar}
      </div>
      ${page.dashboard.closeMain}
      ${!params.all ? createNewAlbum : ''}
      ${createAlbumsFilter}
    `

    const table = document.querySelector('#table')

    for (let i = 0; i < albums.length; i++) {
      const album = albums[i]
      const urlPath = '/a/'
      const albumUrlText = urlPath + album.identifier
      const albumUrl = homeDomain + albumUrlText

      const selected = page.selected[page.currentView].includes(album.id)
      if (!selected) unselected = true

      // Prettify
      album.hasZip = album.zipSize !== null
      album.prettyDate = page.getPrettyDate(new Date(album.timestamp * 1000))
      album.prettyZipDate = album.hasZip ? page.getPrettyDate(new Date(album.zipGeneratedAt * 1000)) : null
      album.isZipExpired = album.hasZip && !(album.zipGeneratedAt > album.editedAt)

      // Server-side explicitly expect this value to consider an album as disabled
      const enabled = album.enabled !== 0
      page.cache[album.id] = {
        name: album.name,
        download: album.download,
        public: album.public,
        description: album.description,
        descriptionHtml: album.descriptionHtml,
        enabled,
        homeDomain,
        urlPath,
        identifier: album.identifier
      }

      const tr = document.createElement('tr')
      tr.dataset.id = album.id
      tr.classList.add('hover:bg-mute', 'has-[:checked]:bg-mute', '[.grid-view_&]:grid', '[.grid-view_&]:ring-1', '[.grid-view_&]:ring-inset', '[.grid-view_&]:ring-line', '[.grid-view_&]:rounded-lg', '[.grid-view_&]:relative', '[.grid-view_&]:text-center', '[.grid-view_&]:has-[:checked]:ring-2', '[.grid-view_&]:has-[:checked]:ring-main')
      tr.dataset.repeat = '9'

      tr.innerHTML = `
        <td class="controls px-4 py-3 pe-0 w-9 whitespace-nowrap relative [.grid-view_&]:static [.grid-view_&]:py-4">
          <input type="checkbox" class="checkbox" name="checkbox-${i}" title="Select" data-index="${i}" data-action="select"${selected ? ' checked' : ''}>
        </td>
        <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:pb-0">
          <a class="[.grid-view_&]:grid [.grid-view_&]:gap-4 [.grid-view_&]:text-center" href="#">
            <span class="text-lead font-medium [.grid-view_&]:truncate">${album.id}</span>
          </a>
        </td>
        <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden ${enabled ? '' : 'text-gray-70 line-through'}">${album.name}</td>
        <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden views-placeholder" data-identifier="${album.identifier}">Loading...</td>
        <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden">${album.uploads}</td>
        <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden" data-bytes="${album.size}">${page.getPrettyBytes(album.size)}</td>
        <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden"><span class="inline-block whitespace-normal max-w-[10ch]" data-timestamp="${album.timestamp}">${album.prettyDate}</span></td>
        <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:hidden"><a ${enabled && album.public ? '' : 'class="is-linethrough" '}href="${albumUrl}" target="_blank">${albumUrlText}</a></td>
        <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:absolute [.grid-view_&]:end-2 [.grid-view_&]:top-2 [.grid-view_&]:p-0" data-id="${album.id}">
          <div class="flex gap-2 justify-end" data-id="${album.id}">
            <button class="btn btn-seco-outline btn-sm p-0 tooltip-top [.grid-view_&]:hidden" aria-label="Edit album" type="button" data-action="edit-album">
              <span class="ic-edit-02 text-base" aria-hidden="true"></span>
            </button>
            <button class="btn btn-seco-outline btn-sm p-0 tooltip-top" aria-label="View uploads" type="button" title="${album.uploads ? 'View uploads' : 'Album doesn\'t have uploads'}" data-action="view-album-uploads" ${album.uploads ? '' : 'disabled'}>
              <span class="ic-eye text-base" aria-hidden="true"></span>
            </button>
            <button class="btn btn-seco-outline btn-sm p-0 tooltip-top clipboard-js" aria-label="Copy link" type="button" ${album.public ? `data-clipboard-text="${albumUrl}"` : 'disabled'}>
              <span class="ic-copy-02 text-base" aria-hidden="true"></span>
            </button>
            <button class="btn btn-seco-outline btn-sm p-0 tooltip-top" aria-label="Delete" type="button" data-action="delete-album">
              <span class="ic-trash-01 text-base" aria-hidden="true"></span>
            </button>
          </div>
        </td>
      `

      table.appendChild(tr)
      page.checkboxes = table.querySelectorAll('.checkbox[data-action="select"]')
    }

    console.log('Fetching views for albums...')
    const rows = document.querySelectorAll('#table tr')
    rows.forEach(row => {
      const identifier = row.querySelector('.views-placeholder').dataset.identifier;
      axios.get(`https://stats.bunkr.ru/api/album/stats/${identifier}`)
        .then(viewsResponse => {
          // Check if the API response contains an error key
          if (viewsResponse.data.error && viewsResponse.data.error === "Album not found") {
            // If the error is "Album not found", set the view count to 0
            row.querySelector('.views-placeholder').innerText = 0;
          } else {
            // Otherwise, use the viewCount from the API response
            row.querySelector('.views-placeholder').innerText = viewsResponse.data.viewCount;
          }
        })
        .catch(error => {
          console.error(`Error fetching views for ${identifier}:`, error);
          // Optionally, handle the axios error by also setting the view count to 0
          row.querySelector('.views-placeholder').innerText = 0;
        });
    });

    const selectAll = document.querySelector('#selectAll')
    if (selectAll && !unselected) {
      selectAll.checked = true
      selectAll.title = 'Unselect all'
    }

    page.selectGoTo()

    page.fadeInDom()

    const pageNum = albums.length ? params.pageNum : 0
    if (params.forceScroll ||
      page.prevPageNums[page.currentView] === null ||
      page.prevPageNums[page.currentView] !== pageNum) {
      page.scrollToDom()
    }

    page.updateTrigger(params.trigger, 'active')

    page.updateSelectedItems(page.selected[page.currentView].length)

    if (page.currentView === 'albumsAll') {
      page.views[page.currentView].filters = params.filters
    }
    page.views[page.currentView].pageNum = page.prevPageNums[page.currentView] = pageNum
  }).catch(error => {
    page.updateTrigger(params.trigger)
    page.onAxiosError(error)
  })
}

page.showModal = (identifier) => {
  var selector = `#${identifier}`
  document.querySelector(selector).classList.remove('hidden')
  document.querySelector(selector).classList.add('show')
}

page.hideModal = (identifier) => {
  var selector = `#${identifier}`
  document.querySelector(selector).classList.remove('show')
  document.querySelector(selector).classList.add('hidden')
}

page.closeModal = (element) => {
  let parent = element.parentNode
  parent = parent.parentNode
  let modal = parent.parentNode // modal
  let selector = modal.id
  if (!selector) {
    modal = modal.parentNode // form
    selector = modal.id
  }
  page.hideModal(selector)
}

page.selectGoTo = () => {
  if (document.querySelectorAll('.my-select').length) {
    var mySelect = document.querySelectorAll('.my-select');
    mySelect.forEach(select => {
      select.addEventListener('change', function () {
        var element = this
        element.dataset.goto = this.value
        page.switchPage('page-goto', element)
      })
    })
  }
}

page.editAlbum = id => {
  const album = page.cache[id]
  if (!album) return

  const albumUrlText = album.urlPath + album.identifier
  const albumUrl = album.homeDomain + albumUrlText

  const div = document.createElement('div')

  div.innerHTML = `
	<div class="bg-back/80-xxx fixed-xxx inset-0 w-full-xxx h-full-xxx z-50 place-items-end pt-12-xxx sm:p-12-xxx sm:place-items-center hidden [&.show]:grid show">
		<div class="bg-mute p-4  w-full rounded-t-xl max-h-full grid auto-rows-max gap-6 overflow-auto sm:rounded-lg sm:max-w-md sm:p-6 text-left">
      <div class="grid auto-rows-max gap-4 relative">
				<span class="ic-folder-plus w-12 h-12 ic-before before:text-2xl text-main bg-main/10 rounded-full grid place-content-center"></span>
				<div class="text-2xl font-bold text-subs font-cabinet">Edit album: ${album.name}</div>
			</div>
			<div class="grid auto-rows-max gap-4">
				<div class="grid auto-rows-max gap-1">
					<label class="font-semibold text-subs" for="swalName">Name</label>
					<input class="bg-body sm:text-sm" type="text" id="swalName" placeholder="Name" maxlength="${page.albumTitleMaxLength}" value="${(album.name || '').substring(0, page.albumTitleMaxLength)}">
				</div>
				<div class="grid auto-rows-max gap-1">
					<label class="font-semibold text-subs" for="swalDescription">Description</label>
					<textarea id="swalDescription" class="textarea" placeholder="Description (this not shown to the public)" rows="2" maxlength="${page.albumDescMaxLength}">${(album.description || '').substring(0, page.albumDescMaxLength)}</textarea>
          <p class="help text-xs"><b>Markdown supported.</b><br/>
          Max length is ${page.albumDescMaxLength} characters.</p>
				</div>
        
        ${album.descriptionHtml ? `
          <div class="grid auto-rows-max gap-1">
            <div class="content swal-display-description-preview text-sm">
              ${album.descriptionHtml}
            </div>
            <p class="text-subs text-xs">Save changes then re-open this Edit prompt to refresh this preview.</p>
          </div>`: ''}

        ${page.currentView === 'albumsAll' && page.permissions.moderator ? `
          <div>
            <label class="inline-flex items-center gap-2 py-1">
              <input id="swalEnabled" class="bg-body p-0 shrink-0" type="checkbox" ${album.enabled ? 'checked' : ''}>
              <span class="font-semibold text-subs text-xs">Enabled</span>
            </label>
          </div>`: ''}
        
        <div>
					<label class="inline-flex items-center gap-2 py-1">
						<input id="swalDownload" class="bg-body p-0 shrink-0" type="checkbox" ${album.download ? 'checked' : ''}>
						<span class="font-semibold text-subs text-xs">Enable Public Listing on bunkr-albums.io</span>
					</label>
				</div>
				<div>
					<label class="inline-flex items-center gap-2 py-1">
						<input id="swalPublic" class="bg-body p-0 shrink-0" type="checkbox" ${album.public ? 'checked' : ''}>
						<span class="font-semibold text-subs text-xs">Enable public link</span>
					</label>
				</div>
        <div>
					<label class="inline-flex items-center gap-2 py-1">
						<input id="swalRequestLink" class="bg-body p-0 shrink-0" type="checkbox">
						<span class="font-semibold text-subs text-xs">Request new public link</span>
					</label>
				</div>
        <div>
					<label class="inline-flex items-center gap-2 py-1">
						<p>Current public link: <a href="${albumUrl}" target="_blank" class="is-underline">${albumUrlText}</a></p>
					</label>
				</div>
			</div>
		</div>
	</div>
  `

  swal({
    // title: 'Edit Album',
    // icon: 'info',
    content: div,
    className: 'swal-edit-form',
    buttons: {
      cancel: {
        text: 'Cancel',
        className: 'btn btn-lg btn-seco font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full max-[425px]:order-last',
        visible: true,
        closeModal: true,
      },
      confirm: {
        text: 'Update',
        className: 'btn btn-lg btn-main font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full',
        closeModal: true
      }
    },
  }).then(value => {
    if (!value) return

    const post = {
      id,
      name: document.querySelector('#swalName').value.trim(),
      description: document.querySelector('#swalDescription').value.trim(),
      download: document.querySelector('#swalDownload').checked,
      public: document.querySelector('#swalPublic').checked,
      requestLink: document.querySelector('#swalRequestLink').checked
    }

    if (page.currentView === 'albumsAll' && page.permissions.moderator) {
      post.enabled = document.querySelector('#swalEnabled').checked
    }

    axios.post('api/albums/edit', post).then(response => {
      if (!response) return

      if (response.data.success === false) {
        if (response.data.description === 'No token provided') {
          return page.verifyToken(page.token)
        } else {
          return swal('An error occurred!', response.data.description, 'error')
        }
      }

      if (response.data.identifier) {
        swal('Success!', `The album's new identifier is: ${response.data.identifier}.`, 'info')
      } else if (response.data.name !== album.name) {
        swal('Success!', `The album was renamed to: ${response.data.name}.`, 'info')
      } else {
        swal('Success!', 'The album was edited.', 'info', {
          buttons: false,
          timer: 1500
        })
      }

      page.getAlbumsSidebar()
      // Reload albums list
      // eslint-disable-next-line compat/compat
      page.getAlbums(Object.assign(page.views[page.currentView], {
        autoPage: true
      }))
    }).catch(page.onAxiosError)
  })
}

page.disableAlbum = id => {
  swal({
    title: 'Are you sure?',
    text: 'This won\'t delete the uploads associated with the album!',
    icon: 'warning',
    dangerMode: true,
    buttons: {
      cancel: true,
      confirm: {
        text: 'Yes, disable it!',
        closeModal: false
      },
      purge: {
        text: 'Umm, delete the uploads, please?',
        value: 'purge',
        className: 'swal-button--danger',
        closeModal: false
      }
    }
  }).then(proceed => {
    if (!proceed) return

    axios.post('api/albums/disable', {
      id,
      purge: proceed === 'purge'
    }).then(response => {
      if (response.data.success === false) {
        const failed = Array.isArray(response.data.failed)
          ? response.data.failed
          : []

        if (response.data.description === 'No token provided') {
          return page.verifyToken(page.token)
        } else if (failed.length) {
          return swal('An error occurred!', `Unable to delete ${failed.length} of the album's upload${failed.length === 1 ? '' : 's'}.`, 'error')
        } else {
          return swal('An error occurred!', response.data.description, 'error')
        }
      }

      swal('Disabled!', 'The album has been disabled.', 'success', {
        buttons: false,
        timer: 1500
      })

      page.getAlbumsSidebar()
      // Reload albums list
      // eslint-disable-next-line compat/compat
      page.getAlbums(Object.assign(page.views[page.currentView], {
        autoPage: true
      }))
    }).catch(page.onAxiosError)
  })
}

page.deleteAlbum = id => {
  swal({
    title: 'Are you sure?',
    text: 'You won\'t be able to recover this album!\n' +
      'This also won\'t delete the uploads associated with the album!',
    className: 'swal-general',
    icon: 'warning',
    dangerMode: true,
    buttons: {
      cancel: true,
      confirm: {
        text: 'Yes, delete it!',
        closeModal: false
      },
      purge: {
        text: 'Umm, delete the uploads, please?',
        value: 'purge',
        className: 'swal-button--danger',
        closeModal: false
      }
    }
  }).then(proceed => {
    if (!proceed) return

    axios.post('api/albums/delete', {
      id,
      purge: proceed === 'purge'
    }).then(response => {
      if (response.data.success === false) {
        const failed = Array.isArray(response.data.failed)
          ? response.data.failed
          : []

        if (response.data.description === 'No token provided') {
          return page.verifyToken(page.token)
        } else if (failed.length) {
          return swal('An error occurred!', `Unable to delete ${failed.length} of the album's upload${failed.length === 1 ? '' : 's'}.`, 'error')
        } else {
          return swal('An error occurred!', response.data.description, 'error')
        }
      }

      swal('Disabled!', 'The album has been deleted.', 'success', {
        buttons: false,
        timer: 1500
      })

      page.getAlbumsSidebar()
      // Reload albums list
      // eslint-disable-next-line compat/compat
      page.getAlbums(Object.assign(page.views[page.currentView], {
        autoPage: true
      }))
    }).catch(page.onAxiosError)
  })
}

page.submitAlbum = element => {
  page.updateTrigger(element, 'loading')

  axios.post('api/albums', {
    name: document.querySelector('#albumName').value.trim(),
    description: document.querySelector('#albumDescription').value.trim()
  }).then(response => {
    if (!response) return

    page.updateTrigger(element)
    if (response.data.success === false) {
      if (response.data.description === 'No token provided') {
        return page.verifyToken(page.token)
      } else {
        return swal('An error occurred!', response.data.description, 'error')
      }
    }

    swal({
      title: 'Woohoo!',
      text: 'Album was created successfully.',
      icon: 'info',
      className: 'swal-general',
      buttons: false,
      timer: 1500
    })
    page.getAlbumsSidebar()
    page.getAlbums({
      pageNum: -1
    })
    page.hideModal('createNewAlbum')
  }).catch(error => {
    page.updateTrigger(element)
    page.onAxiosError(error)
  })
}

page.getAlbumsSidebar = () => {
  axios.get('api/albums', { headers: { simple: '1' } }).then(response => {
    if (!response) return;

    if (response.data.success === false) {
      if (response.data.description === 'No token provided') {
        return page.verifyToken(page.token);
      } else {
        return swal('An error occurred!', response.data.description, 'error');
      }
    }

    const albums = response.data.albums;
    const count = response.data.count;
    const albumsSidebar = document.querySelector('#albumsSidebar');

    // Clear albums sidebar if necessary
    const oldAlbums = albumsSidebar.querySelectorAll('li > a');
    const diffCount = oldAlbums.length !== count;
    if (oldAlbums.length) {
      for (let i = 0; i < oldAlbums.length; i++) {
        page.menus.splice(page.menus.indexOf(oldAlbums[i]), 1);
      }
      albumsSidebar.innerHTML = '';
    }

    page.albumsSidebarCollapse.innerText = page.albumsSidebarCollapsible.collapsed()
      ? page.albumsSidebarCollapse.dataset.textExpand
      : page.albumsSidebarCollapse.dataset.textCollapse;

    if (!albums || !albums.length) {
      page.albumsSidebarCollapsible.collapse();
      page.albumsSidebarCollapse.setAttribute('disabled', 'disabled');
      return;
    }

    for (let i = 0; i < albums.length; i++) {
      const album = albums[i];
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.id = album.id;
      a.className = 'is-relative btn btn-nav';
      a.innerHTML = album.name;

      a.addEventListener('click', event => {
        page.getUploads({
          album: parseInt(event.currentTarget.id),
          trigger: event.currentTarget
        });
      });
      page.menus.push(a);

      li.appendChild(a);
      albumsSidebar.appendChild(li);
    }

    // Force refresh sidebar rendering
    albumsSidebar.style.display = 'none';
    albumsSidebar.offsetHeight; // Trigger reflow
    albumsSidebar.style.display = 'block';

    page.albumsSidebarCollapse.removeAttribute('disabled');
    if (!page.albumsSidebarCollapsible.collapsed() && diffCount) {
      // Since it's not possible to refresh collapsible's height with bulmaCollapsible APIs,
      // forcefully collapse albums sidebar if albums count is different with the previous iteration.
      page.albumsSidebarCollapsible.collapse();
    }
  }).catch(page.onAxiosError);
}


page.changeToken = (params = {}) => {
  page.dom.innerHTML = `
    <main class="py-4 grid auto-rows-max gap-4 2xl:py-8 2xl:gap-8">
			<div class="flex items-center gap-3 flex-wrap">
				<h1 class="font-cabinet text-2xl text-lead py-0.5">Account tokens/codes</h1>
			</div>
			<div class="grid auto-rows-max gap-4 mb-4">
				<div class="grid auto-rows-max gap-1">
					<label class="font-semibold text-subs" for="inviteCode">Your current token:</label>
					<div class="relative">
						<input class="bg-body sm:text-sm pe-12" type="text" id="inviteCode" value="${page.token}" readonly>
						<button class="btn btn-seco-outline btn-sm p-0 tooltip-top absolute end-2 top-2 clipboard-js" aria-label="Copy link" type="button" data-clipboard-text="${page.token}">
							<span class="ic-copy-02 text-base" aria-hidden="true"></span>
						</button>
					</div>
				</div>
				<div>
					<button id="getNewToken" class="btn btn-seco-outline rounded-full font-semibold px-4" type="button">Request new token <span class="ic-refresh-cw-02 text-lg" aria-hidden="true"></span></button>
				</div>
			</div>
			<div class="grid auto-rows-max gap-1">
				<label class="font-semibold text-subs" for="user_code">Invite code:</label>
				<input class="bg-body sm:text-sm" type="text" id="user_code" value="${page.userCode}" readonly>
			</div>
			<div class="bg-fire/5 border border-fire/10 rounded-md p-4 ic-alert-circle ic-before before:text-lg before:text-fire gap-2 flex">
				<div class="flex-1">
					<p><span class="font-bold">Warning</span> Be very careful who you invite. Your account will be banned if you invite abusive uploaders. You have been warned.</p>
				</div>
			</div>
		</main>
  `
  page.fadeInDom()
  page.scrollToDom()
  page.updateTrigger(params.trigger, 'active')

  document.querySelector('#getNewToken').addEventListener('click', event => {
    if (page.isSomethingLoading) return page.warnSomethingLoading()

    const trigger = event.currentTarget
    page.updateTrigger(trigger, 'loading')
    axios.post('api/tokens/change').then(response => {
      if (response.data.success === false) {
        if (response.data.description === 'No token provided') {
          return page.verifyToken(page.token)
        } else {
          page.updateTrigger(trigger)
          return swal('An error occurred!', response.data.description, 'error')
        }
      }

      page.updateTrigger(trigger)
      swal({
        title: 'Woohoo!',
        text: 'Your token was successfully changed.',
        icon: 'success',
        buttons: false,
        timer: 1500
      }).then(() => {
        axios.defaults.headers.common.token = response.data.token
        localStorage[lsKeys.token] = response.data.token
        page.token = response.data.token
        page.changeToken()
      })
    }).catch(error => {
      page.updateTrigger(trigger)
      page.onAxiosError(error)
    })
  })
}

page.changePassword = (params = {}) => {
  page.dom.innerHTML = `
		<main class="py-4 grid auto-rows-max gap-4 2xl:py-8 2xl:gap-8">
      <div class="flex items-center gap-3 flex-wrap">
        <h1 class="font-cabinet text-2xl text-lead py-0.5">Change your password</h1>
      </div>
      <form class="prevent-default">
      <div class="grid auto-rows-max gap-4">
        <div class="grid auto-rows-max gap-1">
          <label class="font-semibold text-subs" for="password">New password</label>
          <div class="relative">
            <input class="bg-body sm:text-sm" type="password" id="password" minlength="6" maxlength="64">
          </div>
        </div>
        <div class="grid auto-rows-max gap-1">
          <label class="font-semibold text-subs" for="passwordConfirm">Re-type new password</label>
          <div class="relative">
            <input class="bg-body sm:text-sm" type="password" id="passwordConfirm" minlength="6" maxlength="64">
          </div>
        </div>
        <div>
          <button type="submit" id="sendChangePassword" class="btn btn-main font-semibold rounded-full" type="button">
            Set new password
          </button>
        </div>
      </div>
      </form>
		</main>
  `
  page.fadeInDom()
  page.scrollToDom()
  page.updateTrigger(params.trigger, 'active')

  document.querySelector('#sendChangePassword').addEventListener('click', event => {
    if (page.isSomethingLoading) return page.warnSomethingLoading()

    if (!page.dom.querySelector('form').checkValidity()) return

    if (document.querySelector('#password').value === document.querySelector('#passwordConfirm').value) {
      page.sendNewPassword(document.querySelector('#password').value, event.currentTarget)
    } else {
      swal({
        title: 'Password mismatch!',
        text: 'Your passwords do not match, please try again.',
        icon: 'error'
      })
    }
  })
}

page.sendNewPassword = (pass, element) => {
  page.updateTrigger(element, 'loading')

  axios.post('api/password/change', { password: pass }).then(response => {
    if (response.data.success === false) {
      if (response.data.description === 'No token provided') {
        return page.verifyToken(page.token)
      } else {
        page.updateTrigger(element)
        return swal('An error occurred!', response.data.description, 'error')
      }
    }

    page.updateTrigger(element)
    swal({
      title: 'Woohoo!',
      text: 'Your password was successfully changed.',
      icon: 'success',
      buttons: false,
      timer: 1500
    }).then(() => {
      page.changePassword()
    })
  }).catch(error => {
    page.updateTrigger(element)
    page.onAxiosError(error)
  })
}

page.getUsers = (params = {}) => {
  if (!page.permissions.admin) return swal('An error occurred!', 'You cannot do this!', 'error')

  if (page.isSomethingLoading) return page.warnSomethingLoading()

  page.updateTrigger(params.trigger, 'loading')

  if (typeof params.pageNum !== 'number') params.pageNum = 0

  const url = `api/users/${params.pageNum}`
  axios.get(url).then(response => {
    if (response.data.success === false) {
      if (response.data.description === 'No token provided') {
        return page.verifyToken(page.token)
      } else {
        page.updateTrigger(params.trigger)
        return swal('An error occurred!', response.data.description, 'error')
      }
    }

    const pages = Math.ceil(response.data.count / 50)
    const users = response.data.users
    if (params.pageNum && (users.length === 0)) {
      page.updateTrigger(params.trigger)
      if (params.autoPage) {
        params.pageNum = pages - 1
        return page.getUsers(params)
      } else {
        return swal('An error occurred!', `There are no more users to populate page ${params.pageNum + 1}.`, 'error')
      }
    }

    page.currentView = 'users'
    page.cache = {}

    if (params.pageNum < 0) params.pageNum = Math.max(0, pages + params.pageNum)
    const pagination = page.paginate(response.data.count, 50, params.pageNum)

    const createUsersFilter = ``

    const filter = `
      <div class="column">
        <form class="prevent-default">
          <div class="field has-addons">
            <div class="control is-expanded">
              <input id="filters" class="input is-small" type="text" placeholder="Filter users (WIP)" value="${page.escape(params.filters || '')}" disabled>
            </div>
            <div class="control">
              <button type="button" class="button is-small is-primary is-outlined" title="Help? (WIP)" data-action="user-filters-help" disabled>
                <span class="icon">
                  <i class="icon-help-circled"></i>
                </span>
              </button>
            </div>
            <div class="control">
              <button type="submit" class="button is-small is-info is-outlined" title="Filter users (WIP)" data-action="filter-users" disabled>
                <span class="icon">
                  <i class="icon-filter"></i>
                </span>
              </button>
            </div>
          </div>
        </form>
      </div>
    `

    // Whether there are any unselected items
    let unselected = false

    const title = `
      <div class="flex items-center gap-3 flex-wrap">
        <h1 class="font-cabinet text-2xl text-lead py-0.5">Manage users</h1>
        <button class="btn btn-wins-light-outline rounded-full font-bold" type="button" data-action="create-user">Create new user <span class="ic-users-plus text-xl"></span></button>
      </div>
    `

    const options = `
      <!-- options -->
      <div class="flex gap-2 items-center flex-wrap">
        <button class="btn btn-seco-ghost text-text rounded-lg" type="button" disabled>
          <span class="ic-filter-lines text-lg" aria-hidden="true"></span> Filter
        </button>
      </div>
    `

    const navBar = `
      <!-- top -->
			<div class="flex items-center justify-between flex-wrap gap-4">
        ${options}
        ${pagination}
      </div>
    `

    const selected = `
    <!-- selected -->
    <div class="bg-mute border border-line p-4 rounded-lg flex flex-wrap justify-between gap-4">
      <div class="flex gap-3 items-center">
        <span id="selectedItems" class="hidden"><span class="font-bold">2</span> selected</span>
        <button class="btn btn-main-light btn-sm text-xs font-semibold" type="button" data-action="clear-selection">Clear selection</button>        
      </div>
      <div class="flex gap-2 w-full flex-wrap sm:w-auto">
        <button class="btn btn-seco-outline btn-sm text-xs gap-1 font-semibold ic-slash-circle-01 ic-before before:text-base flex-1 max-[374px]:flex-none max-[374px]:w-full sm:flex-none" type="button" title="Bulk disable (WIP)" data-action="bulk-disable-users" disabled>Bulk disable</button>
				<button class="btn btn-seco-outline btn-sm text-xs gap-1 font-semibold ic-trash-01 ic-before before:text-base flex-1 max-[374px]:flex-none max-[374px]:w-full sm:flex-none" type="button" title="Bulk delete (WIP)" data-action="bulk-delete-users" disabled>Bulk delete</button>
      </div>
    </div>
    `

    // Do some string replacements for bottom controls
    const bottomNavBar = navBar
      .replace(/for="navMySelect"/, `for="bottomNavMySelect"`)
      .replace(/id="navMySelect"/, `id="bottomNavMySelect"`)

    page.dom.innerHTML = `
      ${page.dashboard.openMain}
      ${title}
      ${navBar}
      ${selected}
      <div class="overflow-x-auto border border-line -mx-6 lg:rounded-lg lg:mx-0 max-[375px]:-mx-4">
        <div class="inline-block min-w-full align-top">
          <table class="min-w-full divide-y divide-line">
            <thead class="[.grid-view_&]:hidden">
              <tr>
                <th scope="col" class="px-4 py-3.5 pe-0 w-9 whitespace-nowrap text-start font-semibold relative">
                  <input id="selectAll" class="checkbox bg-body" type="checkbox" title="Unselect all" data-action="select-all">
                </th>
                <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Username</th>
                <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Uploads</th>
                <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Usage</th>
                <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Group</th>
                <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Registration date</th>
                <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Last token update</th>
                <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-end font-semibold">${response.data.count} total</th>
              </tr>
            </thead>
            <tbody id="table" class="divide-y divide-line">
            </tbody>
          </table>
        </div>
      </div>
      ${bottomNavBar}
      </div>
      ${page.dashboard.closeMain}
      ${createUsersFilter}
    `

    const table = document.querySelector('#table')

    for (let i = 0; i < users.length; i++) {
      const user = users[i]
      const selected = page.selected[page.currentView].includes(user.id)
      if (!selected) unselected = true

      let displayGroup = null
      const groups = Object.keys(user.groups)
      for (let i = 0; i < groups.length; i++) {
        if (!user.groups[groups[i]]) break
        displayGroup = groups[i]
      }

      // Server-side explicitly expects either of these two values to consider a user as disabled
      const enabled = user.enabled !== false && user.enabled !== 0
      page.cache[user.id] = {
        username: user.username,
        groups: user.groups,
        enabled,
        displayGroup
      }

      const prettyDate = user.registration
        ? page.getPrettyDate(new Date(user.registration * 1000))
        : '-'
      const prettyTokenUpdate = user.timestamp
        ? page.getPrettyDate(new Date(user.timestamp * 1000))
        : '-'

      const tr = document.createElement('tr')
      tr.dataset.id = user.id
      tr.classList.add('hover:bg-mute', 'has-[:checked]:bg-mute')
      tr.dataset.repeat = '10'

      tr.innerHTML = `
        <td class="controls px-4 py-3 pe-0 w-9 whitespace-nowrap relative">
          <input type="checkbox" class="checkbox" name="checkbox-${i}" title="Select" data-index="${i}" data-action="select"${selected ? ' checked' : ''}>
        </td>
        <td class="px-4 py-3 whitespace-nowrap text-lead font-semibold ${enabled ? '' : 'line-through'}">${user.username}</td>
        <td class="px-4 py-3 whitespace-nowrap">${user.uploads}</td>
        <td class="px-4 py-3 whitespace-nowrap">${page.getPrettyBytes(user.usage)}</td>
        <td class="px-4 py-3 whitespace-nowrap">${displayGroup}</td>
        <td class="px-4 py-3 whitespace-nowrap"><span class="inline-block whitespace-normal max-w-[10ch]">${prettyDate}</span></td>
        <td class="px-4 py-3 whitespace-nowrap">${prettyTokenUpdate ? prettyTokenUpdate : '-'}</td>
        <td class="px-4 py-3 whitespace-nowrap [.grid-view_&]:absolute [.grid-view_&]:end-2 [.grid-view_&]:top-2 [.grid-view_&]:p-0">
          <div class="flex gap-2 justify-end" data-id="${user.id}">
            <button class="btn btn-seco-outline btn-sm p-0 tooltip-top [.grid-view_&]:hidden" aria-label="Edit user" type="button"  data-action="edit-user">
              <span class="ic-edit-02 text-base" aria-hidden="true"></span>
            </button>
            <button class="btn btn-seco-outline btn-sm p-0 tooltip-top" aria-label="View uploads" type="button" title="${user.uploads ? 'View uploads' : 'User doesn\'t have uploads'}" data-action="view-user-uploads" ${user.uploads ? '' : 'disabled'}>
              <span class="ic-eye text-base" aria-hidden="true"></span>
            </button>
            <button class="btn btn-seco-outline btn-sm p-0 tooltip-top" aria-label="Disable user" type="button" title="${enabled ? 'Disable user' : 'User is disabled'}" data-action="disable-user" ${enabled ? '' : 'disabled'}>
              <span class="ic-slash-circle-01 text-base" aria-hidden="true"></span>
            </button>
            <button class="btn btn-seco-outline btn-sm p-0 tooltip-top" aria-label="Delete" type="button" data-action="delete-user">
              <span class="ic-trash-01 text-base" aria-hidden="true"></span>
            </button>
          </div>
        </td>
      `

      table.appendChild(tr)
      page.checkboxes = table.querySelectorAll('.checkbox[data-action="select"]')
    }

    const selectAll = document.querySelector('#selectAll')
    if (selectAll && !unselected) {
      selectAll.checked = true
      selectAll.title = 'Unselect all'
    }

    page.fadeInDom()

    const pageNum = users.length ? params.pageNum : 0
    if (params.forceScroll ||
      page.prevPageNums[page.currentView] === null ||
      page.prevPageNums[page.currentView] !== pageNum) {
      page.scrollToDom()
    }

    page.updateTrigger(params.trigger, 'active')

    page.updateSelectedItems(page.selected[page.currentView].length)

    page.views[page.currentView].pageNum = page.prevPageNums[page.currentView] = pageNum
  }).catch(error => {
    page.updateTrigger(params.trigger)
    page.onAxiosError(error)
  })
}

page.createUser = () => {
  const groupOptions = Object.keys(page.permissions).map((g, i, a) => {
    const disabled = !(a[i + 1] && page.permissions[a[i + 1]])
    return `<option value="${g}"${disabled ? ' disabled' : ''}>${g}</option>`
  }).join('\n')

  const div = document.createElement('div')
  div.innerHTML = `
  <div class="bg-back/80-xxx fixed-xxx inset-0 w-full-xxx h-full-xxx z-50 place-items-end pt-12-xxx sm:p-12-xxx sm:place-items-center [&.show]:grid show">
    <div class="bg-mute p-4 w-full rounded-t-xl max-h-full grid auto-rows-max gap-6 overflow-auto sm:rounded-lg sm:max-w-md sm:p-8-xxx">
      <div class="grid auto-rows-max gap-4 relative">
        <!--<button class="btn btn-seco-ghost text-xl absolute end-0 top-0 p-0 -m-2 sm:-m-4" type="button" aria-label="Close">
          <span class="ic-x-close"></span>
        </button>-->
        <span class="ic-user-01 w-12 h-12 ic-before before:text-2xl text-main bg-main/10 rounded-full grid place-content-center"></span>
        <div class="text-2xl font-bold text-subs font-cabinet">Create <span class="text-main">new user</span></div>
      </div>
      <div class="grid auto-rows-max gap-4">
        <div class="grid auto-rows-max gap-1">
          <label class="font-semibold text-subs" for="swalUsername">Username</label>
          <input class="bg-body sm:text-sm" type="text" id="swalUsername">
        </div>
        <div class="grid auto-rows-max gap-1">
          <label class="font-semibold text-subs" for="swalPassword">Password (optional)</label>
          <input class="bg-body sm:text-sm" type="text" id="swalPassword">
        </div>
        <div class="grid auto-rows-max gap-1">
          <label class="font-semibold text-subs" for="swalGroup">User group</label>
          <select name="swalGroup" id="swalGroup">
            ${groupOptions}
          </select>
        </div>         
      </div>
    </div>
  </div>
`
  swal({
    title: '',
    icon: '',
    content: div,
    buttons: {
      cancel: {
        className: 'btn btn-lg btn-seco font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full max-[425px]:order-last',
        visible: true,
        closeModal: true
      },
      confirm: {
        className: 'btn btn-lg btn-main font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full',
        closeModal: false
      }
    }
  }).then(proceed => {
    if (!proceed) return

    axios.post('api/users/create', {
      username: document.querySelector('#swalUsername').value,
      password: document.querySelector('#swalPassword').value,
      group: document.querySelector('#swalGroup').value
    }).then(response => {
      if (!response) return

      if (response.data.success === false) {
        if (response.data.description === 'No token provided') {
          return page.verifyToken(page.token)
        } else {
          return swal('An error occurred!', response.data.description, 'error')
        }
      }

      const div = document.createElement('div')
      div.innerHTML = `
        <p>Username: <b>${response.data.username}</b></p>
        <p>Password: <code>${response.data.password}</code></p>
        <p>User group: <b>${response.data.group}</b></p>
      `
      swal({
        title: 'Created a new user!',
        icon: 'info',
        content: div
      })

      // Load last page of users list
      // eslint-disable-next-line compat/compat
      page.getUsers(Object.assign(page.views.users, {
        pageNum: -1
      }))
    }).catch(page.onAxiosError)
  })
}

page.editUser = id => {
  const user = page.cache[id]
  if (!user) return

  let isHigher = false
  const groupOptions = Object.keys(page.permissions).map((g, i, a) => {
    const selected = g === user.displayGroup
    if (selected) {
      isHigher = typeof a[i + 1] !== 'undefined' && page.permissions[a[i + 1]]
    }
    const disabled = !(a[i + 1] && page.permissions[a[i + 1]])
    return `<option value="${g}"${selected ? ' selected' : ''}${disabled ? ' disabled' : ''}>${g}</option>`
  }).join('\n')

  const isDisabledHelper = isHigher ? '' : ' disabled'
  const div = document.createElement('div')
  div.innerHTML = `
    <div class="bg-back/80-xxx fixed-xxx inset-0 w-full-xxx h-full-xxx z-50 place-items-end pt-12-xxx sm:p-12-xxx sm:place-items-center [&.show]:grid show">
      <div class="bg-mute p-4 w-full rounded-t-xl max-h-full grid auto-rows-max gap-6 overflow-auto sm:rounded-lg sm:max-w-md sm:p-8-xxx">
        <div class="grid auto-rows-max gap-4 relative">
          <!--<button class="btn btn-seco-ghost text-xl absolute end-0 top-0 p-0 -m-2 sm:-m-4" type="button" aria-label="Close">
            <span class="ic-x-close"></span>
          </button>-->
          <span class="ic-user-01 w-12 h-12 ic-before before:text-2xl text-main bg-main/10 rounded-full grid place-content-center"></span>
          <div class="text-2xl font-bold text-subs font-cabinet">Edit User <span class="text-main">ID: ${id}</span></div>
        </div>
        <div class="grid auto-rows-max gap-4">
          <div class="grid auto-rows-max gap-1">
            <label class="font-semibold text-subs" for="swalUsername">Username</label>
            <input class="bg-body sm:text-sm" type="text" id="swalUsername" value="${user.username || ''}">
          </div>
          <div class="grid auto-rows-max gap-1">
            <label class="font-semibold text-subs" for="swalGroup">User group</label>
            <select name="swalGroup" id="swalGroup" ${isDisabledHelper}>
              ${groupOptions}
            </select>
          </div>
          <div>
            <label class="inline-flex items-center gap-2 py-1">
              <input id="swalEnabled" class="bg-body p-0 shrink-0" type="checkbox" ${user.enabled ? ' checked' : ''}${isDisabledHelper}
              <span class="font-semibold text-subs">Enabled</span>
            </label>
          </div>
          <div>
            <label class="inline-flex items-center gap-2 py-1">
              <input id="swalResetPassword" class="bg-body p-0 shrink-0" type="checkbox" ${isDisabledHelper}>
              <span class="font-semibold text-subs">Reset password</span>
            </label>
          </div>
          ${isHigher ? '' : `
          <div class="notification is-danger">
            You <b></b> <span class="font-semibold text-subs">cannot</span> modify user in the same or higher group as you.
          </div>
          `}
        </div>
      </div>
    </div>
  `

  swal({
    title: '',
    icon: '',
    content: div,
    buttons: {
      cancel: {
        className: 'btn btn-lg btn-seco font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full max-[425px]:order-last',
        visible: true,
        closeModal: true
      },
      confirm: {
        className: 'btn btn-lg btn-main font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full',
        closeModal: false
      }
    }
  }).then(proceed => {
    if (!proceed) return

    axios.post('api/users/edit', {
      id,
      username: document.querySelector('#swalUsername').value,
      group: document.querySelector('#swalGroup').value,
      enabled: document.querySelector('#swalEnabled').checked,
      resetPassword: document.querySelector('#swalResetPassword').checked
    }).then(response => {
      if (!response) return

      if (response.data.success === false) {
        if (response.data.description === 'No token provided') {
          return page.verifyToken(page.token)
        } else {
          return swal('An error occurred!', response.data.description, 'error')
        }
      }

      let autoClose = true
      const div = document.createElement('div')
      div.classList.add('text-base')

      let displayName = user.username
      if (response.data.update.username !== user.username) {
        div.innerHTML += `<p>${user.username} was renamed into: <b>${response.data.update.username}</b>.</p>`
        autoClose = false
        displayName = response.data.update.username
      }

      if (response.data.update.password) {
        div.innerHTML += `
          <p>${displayName}'s new password is:</p>
          <p><code>${response.data.update.password}</code></p>
        `
        autoClose = false
      }

      if (response.data.update.enabled !== user.enabled) {
        div.innerHTML += `<p>${displayName} has been ${response.data.update.enabled ? 'enabled' : 'disabled'}!</p>`
      }

      if (!div.innerHTML) {
        div.innerHTML = `<p>${displayName} was edited!</p>`
      }

      swal({
        title: 'Success!',
        icon: 'info',
        content: div,
        buttons: {
          cancel: {
            // className: 'btn btn-lg btn-seco font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full max-[425px]:order-last',
            // visible: !autoClose
            visible: false
          },
          confirm: {
            className: 'btn btn-lg btn-main font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full',
            visible: !autoClose
          }
        },
        timer: autoClose ? 1500 : null
      })
      page.getUsers(page.views.users)
    }).catch(page.onAxiosError)
  })
}

page.disableUser = id => {
  const user = page.cache[id]
  if (!user || !user.enabled) return

  const content = document.createElement('div')
  content.classList.add('text-base')
  content.innerHTML = `
    <p>You will be disabling a user named <b>${page.cache[id].username}</b>.</p>
    <p>Their files will remain.</p>
  `

  swal({
    title: 'Are you sure?',
    icon: 'warning',
    content,
    dangerMode: true,
    buttons: {
      cancel: {
        text: 'Cancel',
        className: 'btn btn-lg btn-seco font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full max-[425px]:order-last',
        visible: true,
        closeModal: true,
      },
      confirm: {
        text: 'Yes, disable them!',
        className: 'btn btn-lg btn-main font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full',
        closeModal: true
      }
    }
  }).then(proceed => {
    if (!proceed) return

    axios.post('api/users/disable', { id }).then(response => {
      if (!response) return

      if (response.data.success === false) {
        if (response.data.description === 'No token provided') {
          return page.verifyToken(page.token)
        } else {
          return swal('An error occurred!', response.data.description, 'error')
        }
      }

      swal('Success!', `${page.cache[id].username} has been disabled.`, 'info', {
        buttons: false,
        timer: 1500
      })
      page.getUsers(page.views.users)
    }).catch(page.onAxiosError)
  })
}

page.deleteUser = id => {
  const user = page.cache[id]
  if (!user) return

  const content = document.createElement('div')
  content.innerHTML = `
    <p>You will be deleting a user named <b>${page.cache[id].username}</b>.<p>
    <p>Their uploads will still remain, unless you choose otherwise.</p>
  `

  swal({
    title: 'Are you sure?',
    icon: 'warning',
    content,
    dangerMode: true,
    buttons: {
      cancel: true,
      confirm: {
        text: 'Yes, ONLY the user!',
        closeModal: false
      },
      purge: {
        text: 'Yes, AND their uploads too!',
        value: 'purge',
        className: 'swal-button--danger',
        closeModal: false
      }
    }
  }).then(proceed => {
    if (!proceed) return

    axios.post('api/users/delete', {
      id,
      purge: proceed === 'purge'
    }).then(response => {
      if (!response) return

      if (response.data.success === false) {
        const failed = Array.isArray(response.data.failed)
          ? response.data.failed
          : []

        if (response.data.description === 'No token provided') {
          return page.verifyToken(page.token)
        } else if (failed.length) {
          return swal('An error occurred!', `Unable to delete ${failed.length} of the user's upload${failed.length === 1 ? '' : 's'}.`, 'error')
        } else {
          return swal('An error occurred!', response.data.description, 'error')
        }
      }

      swal('Success!', `${page.cache[id].username} has been deleted.`, 'success', {
        buttons: false,
        timer: 1500
      })

      // Reload users list
      // eslint-disable-next-line compat/compat
      page.getUsers(Object.assign(page.views.users, {
        autoPage: true
      }))
    }).catch(page.onAxiosError)
  })
}

page.generateSlug = id => {
  // const file = page.cache[id]
  const content = document.createElement('div')
  content.innerHTML = `
    <p>You will be generating a new slug for the filename: <b>${page.cache[id].name}</b>.<p>
  `

  swal({
    title: 'Are you sure?',
    icon: 'info',
    content,
    dangerMode: true,
    buttons: {
      cancel: true,
      confirm: {
        text: 'Yes',
        closeModal: false
      }
    }
  }).then(proceed => {
    if (!proceed) return

    axios.post('api/files/slug', {
      id,
      slug: 1
    }).then(response => {
      if (!response) return

      if (response.data.success === false) {
        const failed = Array.isArray(response.data.failed)
          ? response.data.failed
          : []

        if (response.data.description === 'No token provided') {
          return page.verifyToken(page.token)
        } else if (failed.length) {
          return swal('An error occurred!', 'Unable to geberate slug.', 'error')
        } else {
          return swal('An error occurred!', response.data.description, 'error')
        }
      }

      swal('Success!', 'The file has been generated.', 'success', {
        buttons: false,
        timer: 1500
      })

      // Reload upload list
      // eslint-disable-next-line compat/compat
      page.getReports(Object.assign(page.views[page.currentView], {
        autoPage: true
      }))
    }).catch(page.onAxiosError)
  })
}

// Section: Reports
page.getReports = (params = {}) => {
  if (params && params.all && !page.permissions.moderator) {
    return swal('An error occurred!', 'You cannot do this!', 'error')
  }

  if (page.isSomethingLoading) return page.warnSomethingLoading()

  page.updateTrigger(params.trigger, 'loading')

  if (typeof params.pageNum !== 'number') params.pageNum = 0

  const headers = {}
  if (params.all) headers.all = '1'
  if (params.filters) {
    headers.filters = params.filters
    // Send client timezone offset if properly using date: and/or :expiry filters
    // Server will pretend client is on UTC if unset
    if (/(^|\s)(date|expiry):[\d"]/.test(params.filters)) {
      headers.minoffset = new Date().getTimezoneOffset()
    }
  }
  // const url = typeof params.album !== 'undefined'
  //   ? `api/reports/${params.album}/${params.pageNum}`
  //   : `api/reports/${params.pageNum}`

  const url = `api/reports/${params.pageNum}`
  axios.get(url, { headers }).then(response => {
    if (response.data.success === false) {
      if (response.data.description === 'No token provided') {
        return page.verifyToken(page.token)
      } else {
        page.updateTrigger(params.trigger)
        return swal('An error occurred!', response.data.description, 'error')
      }
    }

    const pages = Math.ceil(response.data.count / 50)
    const files = response.data.files
    if (params.pageNum && (files.length === 0)) {
      page.updateTrigger(params.trigger)
      if (params.autoPage) {
        params.pageNum = pages - 1
        return page.getReports(params)
      } else {
        return swal('An error occurred!', `There are no more reports to populate page ${params.pageNum + 1}.`, 'error')
      }
    }

    // page.currentView = params.all ? 'uploadsAll' : 'uploads'
    page.currentView = params.all ? 'reports' : 'reports'
    page.cache = {}

    const albums = response.data.albums
    const users = response.data.users
    // eslint-disable-next-line no-unused-vars
    const basedomain = response.data.basedomain

    if (params.pageNum < 0) params.pageNum = Math.max(0, pages + params.pageNum)
    const pagination = page.paginate(response.data.count, 50, params.pageNum)

    const filter = `
      <div class="column">
        <form class="prevent-default">
          <div class="field has-addons">
            <div class="control is-expanded">
              <input id="filters" class="input is-small" type="text" placeholder="Filter reports" value="${page.escape(params.filters || '')}">
            </div>
            <div class="control">
              <button type="button" class="button is-small is-primary is-outlined" title="Help?" data-action="upload-filters-help"${params.all ? ' data-all="true"' : ''}>
                <span class="icon">
                  <i class="icon-help-circled"></i>
                </span>
              </button>
            </div>
            <div class="control">
              <button type="submit" class="button is-small is-info is-outlined" title="Filter reports" data-action="filter-reports">
                <span class="icon">
                  <i class="icon-filter"></i>
                </span>
              </button>
            </div>
          </div>
        </form>
      </div>
    `
    const extraControls = `
      <div class="columns">
        ${filter}
        <div class="column is-one-quarter">
          <form class="prevent-default">
            <div class="field has-addons">
              <div class="control is-expanded">
                <input id="jumpToPage" class="input is-small" type="number" min="1" max="${pages}" value="${params.pageNum + 1}"${pages === 1 ? ' disabled' : ''}>
              </div>
              <div class="control">
                <button type="submit" class="button is-small is-info is-outlined" title="Jump to page" data-action="jump-to-page">
                  <span class="icon">
                    <i class="icon-paper-plane"></i>
                  </span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    `

    const controls = `
      <div class="columns">
        <div class="column exclusive-operations has-text-left">
        </div>
        <div class="column has-text-centered">
          <a class="button is-small is-danger is-outlined" title="List view" data-action="view-list">
            <span class="icon">
              <i class="icon-th-list"></i>
            </span>
          </a>
          <a class="button is-small is-danger is-outlined" title="Thumbs view" data-action="view-thumbs">
            <span class="icon">
              <i class="icon-th-large"></i>
            </span>
          </a>
        </div>
        <div class="column bulk-operations has-text-right">
          <a class="button is-small is-info is-outlined" title="Clear selection" data-action="clear-selection">
            <span class="icon">
              <i class="icon-cancel"></i>
            </span>
          </a>
          ${params.all
        ? ''
        : `<a class="button is-small is-warning is-outlined" title="Bulk add to album" data-action="add-selected-uploads-to-album">
            <span class="icon">
              <i class="icon-plus"></i>
            </span>
          </a>`}
          <!--<a class="button is-small is-danger is-outlined" title="Bulk delete" data-action="bulk-delete-uploads">
            <span class="icon">
              <i class="icon-trash"></i>
            </span>
            <span>Bulk delete</span>
          </a>-->
        </div>
      </div>
    `

    // Do some string replacements for bottom controls
    const bottomFiltersId = 'bFilters'
    const bottomJumpId = 'bJumpToPage'
    const bottomExtraControls = extraControls
      .replace(/id="filters"/, `id="${bottomFiltersId}"`)
      .replace(/(data-action="filter-uploads")/, `$1 data-filtersid="${bottomFiltersId}"`)
      .replace(/id="jumpToPage"/, `id="${bottomJumpId}"`)
      .replace(/(data-action="jump-to-page")/g, `$1 data-jumpid="${bottomJumpId}"`)
    const bottomPagination = pagination
      .replace(/(data-action="page-ellipsis")/g, `$1 data-jumpid="${bottomJumpId}"`)

    // Whether there are any unselected items
    let unselected = false

    const showOriginalNames = page.views[page.currentView].originalNames
    const hasExpiryDateColumn = files.some(file => typeof file.expirydate !== 'undefined')

    for (let i = 0; i < files.length; i++) {
      // Build full URLs
      files[i].file = `${files[i].basedomain}/${files[i].name}`
      if (files[i].thumb) {
        files[i].thumb = `${files[i].thumb}`
      }

      // Determine types
      const extname = files[i].extname.toLowerCase()
      if (page.imageExts.includes(extname)) {
        files[i].type = 'picture'
      } else if (page.videoExts.includes(extname)) {
        files[i].type = 'video'
      } else if (page.audioExts.includes(extname)) {
        files[i].type = 'audio'
      } else {
        files[i].type = 'other'
      }

      files[i].previewable = files[i].thumb || files[i].type === 'audio'

      // Cache bare minimum data for thumbnails viewer
      page.cache[files[i].id] = {
        name: files[i].name,
        original: files[i].original,
        extname: files[i].extname,
        thumb: files[i].thumb,
        file: files[i].file,
        type: files[i].type,
        previewable: files[i].previewable
      }

      // Prettify
      files[i].prettyBytes = page.getPrettyBytes(parseInt(files[i].size))
      files[i].prettyDate = page.getPrettyDate(new Date(files[i].timestamp * 1000))

      if (hasExpiryDateColumn) {
        files[i].prettyExpiryDate = files[i].expirydate
          ? page.getPrettyDate(new Date(files[i].expirydate * 1000))
          : null
      }

      // Update selected status
      files[i].selected = page.selected[page.currentView].includes(files[i].id)
      if (!files[i].selected) unselected = true

      // Appendix (display album or user)
      if (params.all) {
        files[i].appendix = files[i].userid
          ? users[files[i].userid] || ''
          : ''
      } else if (typeof params.album === 'undefined') {
        files[i].appendix = files[i].albumid
          ? albums[files[i].albumid] || ''
          : ''
      }
    }

    if (page.views[page.currentView].type === 'thumbs') {
      page.dom.innerHTML = `
        ${pagination}
        ${extraControls}
        ${controls}
        <div id="table" class="columns is-multiline is-mobile is-centered">
        </div>
        ${controls}
        ${bottomExtraControls}
        ${bottomPagination}
      `

      const table = document.querySelector('#table')

      for (let i = 0; i < files.length; i++) {
        const upload = files[i]
        const div = document.createElement('div')
        div.className = 'image-container column'
        div.dataset.id = upload.id

        if (typeof upload.thumb !== 'undefined') {
          div.innerHTML = `<a class="image" href="${upload.file}" target="_blank"><img alt="${upload.name}" data-src="${upload.thumb}"/></a>`
        } else {
          div.innerHTML = `<a class="image" href="${upload.file}" target="_blank"><h1 class="title">${upload.extname || 'N/A'}</h1></a>`
        }

        div.innerHTML += `
          <input type="checkbox" class="checkbox" title="Select" data-index="${i}" data-action="select"${upload.selected ? ' checked' : ''}>
          <div class="controls">
            ${upload.previewable
            ? ``
            : ''}
                        <a class="button is-small is-info clipboard-js" title="Copy link to clipboard" data-clipboard-text="${upload.finalurl}">
              <span class="icon">
                <i class="icon-clipboard"></i>
              </span>
            </a>
            <a class="button is-small is-info clipboard-js" title="Copy link to clipboard" data-clipboard-text="${upload.finalurl}">
              <span class="icon">
                <i class="icon-clipboard"></i>
              </span>
            </a>
            <!--<a class="button is-small is-warning" title="Add to album" data-action="add-to-album">
              <span class="icon">
                <i class="icon-plus"></i>
              </span>
            </a>-->
            <a class="button is-small is-danger" title="Delete Report" data-action="delete-report">
              <span class="icon">
                <i class="icon-trash"></i>
              </span>
            </a>
          </div>
          <div class="details">
            <p class="name" title="${upload.file}">${upload.name}</p>
            ${showOriginalNames ? `<p class="originalname" title="${upload.original}">${upload.original}</p>` : ''}
            <p class="prettybytes" data-bytes="${upload.size}">${upload.appendix ? `<span>${upload.appendix}</span> – ` : ''}${upload.prettyBytes}</p>
            ${hasExpiryDateColumn && upload.prettyExpiryDate
            ? ''
            : ''}
          </div>
        `

        table.appendChild(div)
        page.checkboxes = table.querySelectorAll('.checkbox[data-action="select"]')
      }
    } else {
      const allAlbums = params.all && params.filters && params.filters.includes('albumid:')
      page.dom.innerHTML = `
        ${pagination}
        ${extraControls}
        ${controls}
        <div class="table-container has-text-left">
          <table class="table is-narrow is-fullwidth is-hoverable">
            <thead>
              <tr>
                <th class="controls"><input id="selectAll" class="checkbox" type="checkbox" title="Select all" data-action="select-all"></th>
                <th title="Key: name">Name</th>
                ${showOriginalNames ? '<th title="Key: original">Original name</th>' : ''}
                ${typeof params.album === 'undefined' ? `<th title="Key: ${params.all ? 'userid">User' : 'albumid">Album'}</th>` : ''}
                ${allAlbums ? '<th title="Key: albumid">Album</th>' : ''}
                <!--<th title="Key: size">Size</th>-->
                ${params.all ? '<th title="Key: ip">IP</th>' : ''}
                <th title="Key: timestamp">Report date</th>
                <th title="Key: reason">Reason</th>
                <th title="Key: description">Description</th>
                <th class="has-text-right">(${response.data.count} total)</th>
              </tr>
            </thead>
            <tbody id="table">
            </tbody>
          </table>
        </div>
        ${controls}
        ${bottomExtraControls}
        ${bottomPagination}
      `

      const table = document.querySelector('#table')

      for (let i = 0; i < files.length; i++) {
        const upload = files[i]
        const tr = document.createElement('tr')
        tr.dataset.id = upload.id
        tr.innerHTML = `
          <td class="controls"><input type="checkbox" class="checkbox" title="Select" data-index="${i}" data-action="select"${upload.selected ? ' checked' : ''}></td>
          <th class="name"><a href="${upload.finalurl}" target="_blank" title="${upload.finalurl}">${upload.name}</a></th>
          ${showOriginalNames ? `<th class="originalname" title="${upload.original}">${upload.original}</th>` : ''}
          ${typeof params.album === 'undefined' ? `<th class="appendix">${upload.appendix}</th>` : ''}
          ${allAlbums ? `<th class="album">${upload.albumid ? (albums[upload.albumid] || '') : ''}</th>` : ''}
          <!--<td class="prettybytes" data-bytes="${upload.size}">${upload.prettyBytes}</td>-->
          ${params.all ? `<td class="ip"><a href="https://ipinfo.io/${upload.ip || ''}" target="_blank">${upload.ip || ''}</a></td>` : ''}
          <td class="prettydate" data-timestamp="${upload.timestamp}">${upload.prettyDate}</td>
          <td class="reason" data-reason="${upload.reason}">${upload.reason}</td>
          <td class="description" data-description="${upload.description}">${upload.description}</td>
          <td class="controls has-text-right">
            <a class="button is-small is-info is-outlined clipboard-js" title="Copy link to clipboard" data-clipboard-text="${upload.finalurl}">
              <span class="icon">
                <i class="icon-clipboard"></i>
              </span>
            </a>
            <a class="button is-small is-secondary is-outlined" title="Generate Slug" data-action="generate-slug">
              <span class="icon">
                <i class="icon-pencil"></i>
              </span>
            </a>
            ${params.all
            ? ''
            : ''}
            <a class="button is-small is-danger is-outlined" title="Delete" data-action="delete-report">
              <span class="icon">
                <i class="icon-trash"></i>
              </span>
            </a>
          </td>
        `

        table.appendChild(tr)
        page.checkboxes = table.querySelectorAll('.checkbox[data-action="select"]')
      }
    }

    const selectAll = document.querySelector('#selectAll')
    if (selectAll && !unselected && files.length) {
      selectAll.checked = true
      selectAll.title = 'Unselect all'
    }

    page.fadeInDom()

    const pageNum = files.length ? params.pageNum : 0
    if (params.forceScroll ||
      page.prevPageNums[page.currentView] === null ||
      page.prevPageNums[page.currentView] !== pageNum) {
      const disableSmooth = !params.forceScroll && page.views[page.currentView].type === 'thumbs'
      page.scrollToDom(disableSmooth)
    }

    if (page.views[page.currentView].type === 'thumbs') {
      page.lazyLoad.update()
    }

    page.updateTrigger(params.trigger, 'active')

    if (page.currentView === 'reports') {
      console.log('page.currentView', page.currentView)
      page.views.uploads.album = params.album
    }
    page.views[page.currentView].filters = params.filters
    page.views[page.currentView].pageNum = page.prevPageNums[page.currentView] = pageNum
  }).catch(error => {
    page.updateTrigger(params.trigger)
    page.onAxiosError(error)
  })
}

page.filterReports = element => {
  const filters = document.querySelector(`#${element.dataset.filtersid || 'filters'}`).value
    .trim()
    .replace(/\t/g, ' ')
    .replace(/(^|\s)((albumid|ip|user|date|expiry|is|sort|orderby):)\s+/g, '$2')
  // eslint-disable-next-line compat/compat
  page.getReports(Object.assign(page.views[page.currentView], {
    filters,
    pageNum: 0,
    trigger: element
  }))
}

page.deleteReport = (id, element) => {
  const content = document.createElement('div')
  content.innerHTML = ''
  // const objective = ''

  swal({
    title: 'Are you sure?',
    content,
    icon: 'warning',
    dangerMode: true,
    showCloseButton: true,
    buttons: {
      cancel: true,
      confirm: {
        text: 'Yes, delete it',
        closeModal: false
      }
    }
  }).then(proceed => {
    if (!proceed) return
    axios.post('api/report/delete', {
      field: 'id',
      id
    }).then(response => {
      if (!response) return

      if (response.data.success === false) {
        if (response.data.description === 'No token provided') {
          return page.verifyToken(page.token)
        } else {
          return swal('An error occurred!', response.data.description, 'error')
        }
      }
      swal('Disabled!', 'The report has been removed.', 'success', {
        buttons: false,
        timer: 1500
      })
      // eslint-disable-next-line compat/compat
      page.getReports(Object.assign(page.views[page.currentView], {
        autoPage: true
      }))
    }).catch(page.onAxiosError)
  })
}

// Roughly based on https://github.com/mayuska/pagination/blob/03cac0fb8af3a759bc1220bd3c011b67dbc5e909/index.js
page.paginate = (totalItems, itemsPerPage, currentPage) => {
  const numPages = Math.ceil(totalItems / itemsPerPage);
  currentPage = currentPage + 1; // Convert to 1-based index for display

  return `
  <!-- nav -->
  <nav class="flex justify-between items-center gap-4 flex-col w-full md:w-auto lg:flex-row">
    <div class="flex gap-2 w-full">
      <div class="flex items-center gap-2">
        <label for="pageInput" class="sr-only">Go to page</label>
        <input type="number" id="pageInput" class="w-24 bg-body min-h-10 lg:text-sm text-center" min="1" max="${numPages}" value="${currentPage}" aria-label="Enter page number">
        <button id="goToPageBtn" class="btn btn-md btn-seco" type="button" data-action="jump-to-page">Go</button>
        <span class="btn btn-md btn-seco pointer-events-none"><span class="font-normal">of <span class="font-semibold">${numPages}</span> pages</span></span>
      </div>
        <button class="btn btn-md btn-seco ic-arrow-right ic-after after:text-base after:-scale-x-1 after:order-first p-0 pagination-link" type="button" data-action="page-prev" ${currentPage === 1 ? ' disabled' : ''}><span class="sr-only">Prev</span></button>
        <button class="btn btn-md btn-seco ic-arrow-right ic-after after:text-base p-0 pagination-link" type="button" data-action="page-next" ${currentPage >= numPages ? ' disabled' : ''}><span class="sr-only">Next</span></button>
      </div>
    </nav>
  `;
};

page.getStatistics = (params = {}) => {
  if (!page.permissions.admin) return swal('An error occurred!', 'You cannot do this!', 'error')

  if (page.isSomethingLoading) return page.warnSomethingLoading()

  page.updateTrigger(params.trigger, 'loading')

  const url = 'api/stats'
  axios.get(url).then(response => {
    if (response.data.success === false) {
      if (response.data.description === 'No token provided') {
        return page.verifyToken(page.token)
      } else {
        page.updateTrigger(params.trigger)
        return swal('An error occurred!', response.data.description, 'error')
      }
    }

    let content = ''
    content += page.dashboard.openMain
    content += page.dashboard.setTitle('Statics')

    const keys = Object.keys(response.data.stats)
    for (let i = 0; i < keys.length; i++) {
      let rows = ''
      if (!response.data.stats[keys[i]]) {
        rows += `
          <tr>
            <td>Generating, please try again later\u2026</td>
            <td></td>
          </tr>
        `
      } else {
        try {
          const valKeys = Object.keys(response.data.stats[keys[i]])
          for (let j = 0; j < valKeys.length; j++) {
            const data = response.data.stats[keys[i]][valKeys[j]]
            const type = typeof data === 'object' ? data.type : 'auto'
            const value = typeof data === 'object' ? data.value : data

            let parsed
            switch (type) {
              case 'byte':
                parsed = page.getPrettyBytes(value)
                break
              case 'byteUsage': {
                // Reasoning: https://github.com/sebhildebrandt/systeminformation/issues/464#issuecomment-756406053
                const totalForPercentage = typeof value.available !== 'undefined'
                  ? (value.used + value.available)
                  : value.total
                parsed = `${page.getPrettyBytes(value.used)} / ${page.getPrettyBytes(value.total)} (${(value.used / totalForPercentage * 100).toFixed(2)}%)`
                break
              }
              case 'uptime':
                parsed = page.getPrettyUptime(value)
                break
              case 'auto':
                switch (typeof value) {
                  case 'number':
                    parsed = value.toLocaleString()
                    break
                  default:
                    parsed = value
                }
                break
              default:
                parsed = value
            }

            rows += `
              <tr class="hover:bg-mute has-[:checked]:bg-mute">
								<td class="px-4 py-3 whitespace-nowrap text-lead font-semibold">${valKeys[j]}</td>
								<td class="px-4 py-3 whitespace-nowrap">${parsed}</td>
							</tr>
            `
          }
        } catch (error) {
          rows = `
              <tr>
                <td>Error parsing response. Try again?</td>
                <td></td>
              </tr>
            `
          page.onError(error)
        }
      }

      content += `
        <div class="overflow-x-auto border border-line -mx-6 lg:rounded-lg lg:mx-0 max-[375px]:-mx-4">
          <div class="inline-block min-w-full align-top">
            <table class="min-w-full divide-y divide-line">
              <caption class="bg-soft text-start px-4 py-3 text-lead font-bold">${keys[i]}</caption>
              <colgroup>
                <col class="w-1/2">
                <col class="w-1/2">
              </colgroup>
              <tbody class="divide-y divide-line">
                ${rows}
              </tbody>
            </table>
          </div>
        </div>
      `
    }

    if (Array.isArray(response.data.hrtime)) {
      content += `
        <div class="bg-soft text-start px-4 py-3 text-lead font-bold border border-line rounded-lg">
          Time taken: ${response.data.hrtime[0]}s ${Math.ceil(response.data.hrtime[1] / 1000000)}ms.
        </div>
      `
    }

    content += page.dashboard.closeMain;

    page.dom.innerHTML = content
    page.fadeInDom()
    page.scrollToDom()
    page.updateTrigger(params.trigger, 'active')
  }).catch(error => {
    page.updateTrigger(params.trigger)
    page.onAxiosError(error)
  })
}

page.serverStats = (params = {}) => {
  if (!page.permissions.admin) return swal('An error occurred!', 'You cannot do this!', 'error')

  if (page.isSomethingLoading) return page.warnSomethingLoading()

  page.updateTrigger(params.trigger, 'loading')

  const url = 'https://stats-api.bunkr.pk/master-stats'; // Your actual API endpoint
  axios.get(url).then(response => {
    if (response.data.success === false) {
      if (response.data.description === 'No token provided') {
        return page.verifyToken(page.token)
      } else {
        page.updateTrigger(params.trigger)
        return swal('An error occurred!', response.data.description, 'error')
      }
    }

    let content = ''
    content += page.dashboard.openMain
    content += page.dashboard.setTitle('Server Stats')

    content += `
      <table id="statsTable" class="min-w-full divide-y divide-line [.grid-view_&]:grid [.grid-view_&]:divide-y-0">
        <thead>
          <tr>
            <th class="px-4 py-2">Server Name</th>
            <th class="px-4 py-2">RX (GB/s)</th>
            <th class="px-4 py-2">TX (GB/s)</th>
            <th class="px-4 py-2">Space Left (TB)</th>
            <th class="px-4 py-2">Percent Used (%)</th>
          </tr>
        </thead>
        <tbody style="text-align: center"></tbody>
        <tfoot style="text-align: center">
          <tr>
            <th>Total/Average</th>
            <td id="totalRx"></td>
            <td id="totalTx"></td>
            <td id="totalFree"></td>
            <td id="averagePercent"></td>
          </tr>
        </tfoot>
      </table>
    `;

    page.dom.innerHTML = content
    page.fadeInDom()
    page.scrollToDom()

    const tbody = document.getElementById('statsTable').getElementsByTagName('tbody')[0];
    let totalFree = 0;
    let totalPercent = 0;
    let countValidPercent = 0;

    // Sort the servers by free_gb in ascending order
    response.data.servers.sort((a, b) => a.free_gb - b.free_gb);

    response.data.servers.forEach((server) => {
      const row = tbody.insertRow();
      row.insertCell().textContent = server.server_name;
      row.insertCell().textContent = (server.rx_mbps / 1000).toFixed(3) + ' GB/s';
      row.insertCell().textContent = (server.tx_mbps / 1000).toFixed(3) + ' GB/s';
      row.insertCell().textContent = (server.free_gb / 1024).toFixed(3) + ' TB'; 
      const percentUsed = isNaN(server.percent_used) ? 0 : server.percent_used;
      row.insertCell().textContent = percentUsed.toFixed(2) + '%';

      totalFree += server.free_gb / 1024; 
      if (!isNaN(server.percent_used)) {
        totalPercent += server.percent_used;
        countValidPercent++;
      }
    });

    document.getElementById('totalRx').textContent = (response.data.total_rx_mbps / 1000).toFixed(3) + ' GB/s';
    document.getElementById('totalTx').textContent = (response.data.total_tx_mbps / 1000).toFixed(3) + ' GB/s';
    document.getElementById('totalFree').textContent = totalFree.toFixed(3) + ' TB';
    document.getElementById('averagePercent').textContent = (countValidPercent > 0 ? (totalPercent / countValidPercent).toFixed(2) : '0.00') + '%';

    page.updateTrigger(params.trigger, 'active');
  }).catch(error => {
    page.updateTrigger(params.trigger);
    page.onAxiosError(error);
  });
}

window.addEventListener('DOMContentLoaded', () => {
  // Polyfill Object.assign()
  // eslint-disable-next-line compat/compat
  if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, 'assign', {
      value: function assign(target, varArgs) { // .length of function is 2
        'use strict'
        if (target === null || typeof target === 'undefined') {
          throw new TypeError('Cannot convert undefined or null to object')
        }
        const to = Object(target)
        for (let i = 1; i < arguments.length; i++) {
          const nextSource = arguments[i]
          if (nextSource !== null && typeof nextSource !== 'undefined') {
            for (const nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey]
              }
            }
          }
        }
        return to
      },
      writable: true,
      configurable: true
    })
  }

  // Add 'no-touch' class to non-touch devices
  if (!('ontouchstart' in document.documentElement)) {
    document.documentElement.classList.add('no-touch')
  }

  const selectedKeys = ['uploads', 'uploadsAll', 'albums', 'albumsAll', 'users']
  for (let i = 0; i < selectedKeys.length; i++) {
    const ls = localStorage[lsKeys.selected[selectedKeys[i]]]
    if (ls) page.selected[selectedKeys[i]] = JSON.parse(ls)
  }

  page.preparePage()

  page.clipboardJS = new ClipboardJS('.clipboard-js')

  page.clipboardJS.on('success', () => {
    return swal({
      title: '',
      text: 'The link has been copied to clipboard.',
      icon: 'info',
      className: 'swal-general',
      buttons: false,
      timer: 1500
    })
  })

  // page.clipboardJS.on('error', page.onError)

  page.clipboardJS.on('error', (error) => {
    alert(error)
    page.onError()
  })

  page.lazyLoad = new LazyLoad()

  page.albumsSidebarCollapse = document.querySelector('#albumsSidebarCollapse')

  /* eslint-disable-next-line new-cap */
  page.albumsSidebarCollapsible = new bulmaCollapsible(document.querySelector('#albumsSidebar'))
  page.albumsSidebarCollapsible.on('before:expand', event => {
    page.albumsSidebarCollapse.innerText = page.albumsSidebarCollapse.dataset.textCollapse
  })
  page.albumsSidebarCollapsible.on('before:collapse', event => {
    page.albumsSidebarCollapse.innerText = page.albumsSidebarCollapse.dataset.textExpand
  })
})

/* New Trash bin page */

page.trashBin = async (params = {}) => {
  // Use the token from the `page` object
  const token = page.token;
  if (!token) {
    return swal('Authorization Error', 'User token is missing. Please log in again.', 'error');
  }

  // Set up the initial HTML
  page.dom.innerHTML = `
    <main class="py-4 grid auto-rows-max gap-4 2xl:py-8 2xl:gap-8">
      <div class="flex items-center gap-3 flex-wrap">
        <h1 class="font-cabinet text-2xl text-lead py-0.5">Trash Bin</h1>
      </div>
      <div id="trashBinTableContainer">
        <p>Loading files...</p>
      </div>
    </main>
  `;

  page.fadeInDom();
  page.scrollToDom();
  page.updateTrigger(params.trigger, 'active');

  // Make the API request using Axios
  axios
    .get('/api/tb/files', {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    })
    .then(function (response) {
      const data = response.data;

      // Validate response
      if (!data.success || !Array.isArray(data.files)) {
        throw new Error('Unexpected response format.');
      }

      // Sort by `deleted_date` descending and limit to 30 files
      const files = data.files
        .sort((a, b) => new Date(b.deleted_date) - new Date(a.deleted_date)) // Sort by date descending
        .slice(0, 30); // Limit to the first 30

      // Build the table
      const tableHTML = `
      <div class="announcement" style="
        color: white;
        padding: 14px;
        background: #7766b4;
        border-radius: 8px;
        margin-bottom: 15px;
      "> Only the last 30 deleted files are shown. From newest deleted to oldest.</div>
        <div class="overflow-x-auto border border-line -mx-6 lg:rounded-lg lg:mx-0 max-[375px]:-mx-4 [&.grid-view]:border-0 [&.grid-view]:overflow-visible [&.grid-view]:m-0">
          <div class="inline-block min-w-full align-top">
            <table class="min-w-full divide-y divide-line [.grid-view_&]:grid [.grid-view_&]:divide-y-0">
              <thead class="[.grid-view_&]:hidden">
                <tr>
                  <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">ID</th>
                  <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">File Name <span class="text-gray-500 text-sm">[album_name]</span></th>
                  <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Deleted Date</th>
                  <th scope="col" class="px-4 py-3.5 whitespace-nowrap text-start font-semibold">Reason</th>
                </tr>
              </thead>
              <tbody id="table" class="divide-y divide-line [.grid-view_&]:grid [.grid-view_&]:gap-4 [.grid-view_&]:divide-y-0 [.grid-view_&]:grid-cols-repeat [.grid-view_&]:[--size:14rem]">
                ${files
                  .map(
                    file => `
                      <tr>
                        <td class="px-4 py-3.5">${file.id}</td>
                        <td class="px-4 py-3.5">
                          ${file.original}
                          <span class="text-gray-500 text-sm">${file.album_name ? `[${file.album_name}]` : ''}</span>
                        </td>
                        <td class="px-4 py-3.5">${file.deleted_date || 'N/A'}</td>
                        <td class="px-4 py-3.5">${file.deleted_reason || 'No reason provided'}</td>
                      </tr>
                    `
                  )
                  .join('')}
              </tbody>
            </table>
          </div>
        </div>
      `;

      // Display the table
      document.querySelector('#trashBinTableContainer').innerHTML = tableHTML;
    })
    .catch(function (error) {
      // Handle errors
      const errorMessage =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        'An unexpected error occurred.';
      document.querySelector('#trashBinTableContainer').innerHTML = `
        <p class="text-red-600">An error occurred: ${errorMessage}</p>
      `;
    });
};

/* New edit file func */

page.editFile = id => {
  const file = page.cache[id]; // Get the file details from the cache
  if (!file) return;

  // Extract the file name and extension
  const fileNameParts = file.original.split('.');
  const fileExtension = fileNameParts.pop(); // Get the extension
  const fileNameWithoutExtension = fileNameParts.join('.'); // Join the rest as the name

  // Create the modal content
  const div = document.createElement('div');
  div.innerHTML = `
	<div class="bg-back/80-xxx fixed-xxx inset-0 w-full-xxx h-full-xxx z-50 place-items-end pt-12-xxx sm:p-12-xxx sm:place-items-center hidden [&.show]:grid show">
		<div class="bg-mute p-4  w-full rounded-t-xl max-h-full grid auto-rows-max gap-6 overflow-auto sm:rounded-lg sm:max-w-md sm:p-6 text-left">
      <div class="grid auto-rows-max gap-4 relative">
				<button class="btn btn-seco-ghost text-xl absolute end-0 top-0 p-0 -m-2 sm:-m-4" type="button" aria-label="Close">
					<span class="ic-x-close"></span>
				</button>
				<span class="ic-folder-plus w-12 h-12 ic-before before:text-2xl text-main bg-main/10 rounded-full grid place-content-center"></span>
				<div class="text-2xl font-bold text-subs font-cabinet">Edit file</div>
			</div>
			<div class="grid auto-rows-max gap-4">
          <div class="grid auto-rows-max gap-1">
            <label class="font-semibold text-subs" for="swalName">File Name</label>
            <input 
              class="bg-body sm:text-sm"
              type="text"
              id="swalName"
              placeholder="File Name"
              maxlength="${page.albumTitleMaxLength}"
              value="${fileNameWithoutExtension}"
            >
            <p class="text-xs text-subs mt-1">The file extension <strong>.${fileExtension}</strong> will remain unchanged.</p>
          </div>
        </div>
      </div>
    </div>
  `;

  // Show SweetAlert2 modal with the created content
  swal({
    content: div,
    className: 'swal-edit-form',
    buttons: {
      cancel: {
        text: 'Cancel',
        className: 'btn btn-lg btn-seco font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full max-[425px]:order-last',
        visible: true,
        closeModal: true,
      },
      confirm: {
        text: 'Update',
        className: 'btn btn-lg btn-main font-semibold text-base flex-1 max-[425px]:flex-none max-[425px]:w-full w-full',
        closeModal: true
      }
    },
  }).then(value => {
    if (!value) return;

    // Get the updated file name from the input field
    const newName = document.querySelector('#swalName').value.trim();
    if (!newName) {
      swal('Error', 'File name cannot be empty.', 'error');
      return;
    }

    // Combine the updated name with the file extension
    const fullFileName = `${newName}.${fileExtension}`;

    // Prepare the POST request payload
    const post = {
      id,
      newName: fullFileName,
    };

    // Send the request to the server with the Authorization header
    axios.post('/api/file/rename', post, {
      headers: {
        Authorization: `Bearer ${page.token}`, // Add the Authorization token
      },
    }).then(response => {
      if (!response) return;

      if (response.data.success === false) {
        if (response.data.description === 'No token provided') {
          return page.verifyToken(page.token);
        } else {
          return swal('An error occurred!', response.data.description, 'error');
        }
      }

      swal('Success!', `The file was successfully renamed. Refresh the page to view the file with the new name.`, 'success', {
        buttons: false,
        timer: 1500,
      });

      // Refresh the file view or cache
      page.getUploads(Object.assign(page.views[page.currentView], {
        autoPage: true,
      }));
    }).catch(page.onAxiosError);
  });
};

page.purgeCache = id => {
  const content = document.createElement('div')
  content.innerHTML = `
    <p>Doing this will delete the page cache of the album</b>.</p>
  `

  swal({
    title: 'Are you sure?',
    icon: 'info',
    content,
    dangerMode: true,
    buttons: {
      cancel: true,
      confirm: {
        text: 'Yes',
        closeModal: false
      }
    }
  }).then(proceed => {
    if (!proceed) return

    axios.post(`https://bunkr.ph/api/cache/delete?type=album&key=${identifier}`).then(response => {
      if (!response) return

      if (response.data && response.data.message === 'Cache deleted successfully') {
        swal('Success!', 'Cache has been deleted successfully.', 'success', {
          buttons: false,
          timer: 1500
        })
      } else {
        // Handle any other response or error message
        swal('Error!', response.data.message || 'An error occurred.', 'error')
      }
    }).catch(error => {
      // Handle network errors or other axios errors
      page.onAxiosError(error)
    })
  })
}